import router from '@/router/index';
import Vue from 'vue';
import moment from 'moment';
import config from  '../config';

var isProxy = config.VUE_APP_IS_PROXY === "true";
var dashboardUrl = config.VUE_APP_SWITCH_DASHBOARD_URL;
var reconModuleUrl = config.VUE_APP_RECON_MODULE_URL;
var billingSytemPath = config.VUE_APP_BILLING_SYSTEM_PATH;
var billingSystemUrl = config.VUE_APP_BILLING_SYSTEM_URL;
var walletModuleUrl = config.VUE_APP_WALLET_MODULE_URL;
var reconDashboardUrl = config.VUE_APP_RECON_DASHBOARD_URL;


export default {
    /**
     * Get list of TDM Roles
     */
    async getAllGroups() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/listOfGroups`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/listOfGroups`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of roles." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllRoles() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/listRoles`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/listRoles`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of roles." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async listUserRoles(username) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/listUserRoles`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/listUserRoles`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            username: username


        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of users." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getUsers(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `tdm/user/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            firstName: query.firstName ?? '',
            lastName: query.lastName ?? '',
            username: query.username ?? '',
            mobileNumber: query.mobileNumber ?? '',
            dateFrom: query.dateFrom ?? '',
            dateTo: query.dateTo ?? '',
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of users." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createUser(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/create`
        }
        const user = `${formData.username}:${formData.password}`
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'user': `${btoa(user)}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            firstName: `${formData.firstName}`,
            lastName: `${formData.lastName}`,
            email: `${formData.email}`,
            mobileNumber: `${formData.mobileNumber}`,
            remarks: `${formData.remarks}`,
            role: `${formData.role}`,
            isEnabled: `${formData.isEnabled}`,
            paymentAgent: formData.paymentAgent ? formData.paymentAgent.code ?? null : null
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async updateUser(formData) {

        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            username: `${formData.username}`,
            firstName: `${formData.firstName}`,
            lastName: `${formData.lastName}`,
            email: `${formData.email}`,
            mobileNumber: `${formData.mobileNumber}`,
            remarks: `${formData.remarks}`,
            role: `${formData.role}`,
            isEnabled: `${formData.isEnabled}`,
            paymentAgent: formData.paymentAgent ? formData.paymentAgent.code ?? null : null
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
     * Update Account User's Password
     * parameters: JSON Object containing:
     * oldPassword: string
     * newPassword: string
     * username: string
     */
    //not used
    async updateAccountPassword(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/userManagement/updatePassword`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/userManagement/updatePassword`
        }
        const user = `${parameters.username}:${parameters.oldPassword}:${parameters.newPassword}`
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'user': `${btoa(user)}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {}
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating your password." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            if (error && error.response && error.response.data) {
                console.log(error.response)
                if (error.response.data.message) {
                    return { error: error.response.data.message };
                } else {
                    return { error: error.response.data };
                }
            } else {
                return { error: "Error: " + error + "" };
            }
        }
    },

    /**
     * Get total amounts and transaction count of transactions per day for Merchant Users
     */
    async getMerchantTransactionsTotal(limit = 10, offset = 0, merchantId) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/dashboard/merchantTotals`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/dashboard/merchantTotals`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            merchantID: merchantId
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * merchantTotals - JSON array of transaction objects
                 * transaction object contains:
                 * businessDate - datestring; date the transactions are transacted (yyyy-MM-dd HH:mm:ss.S)
                 * lastUpdated - datestring; date the transaction object is last updated (yyyy-MM-dd HH:mm.ss.S)
                 * transactionAmount - int; total amount computed from the list of transactions per day
                 * dataName - string; name to be displayed for the data in the chart
                 * id - int; transaction object identifier
                 * transactionCount - int; total transaction count computed from the list of transactions per day
                 * merchantName - string
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
     * Get total amounts and transaction count of transactions per day for Admin Users
     */
    async getTransactionsTotal(limit = 10, offset = 0) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/dashboard/dashboardTotals`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/dashboard/dashboardTotals`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * dashboardTotals - JSON array of transaction objects
                 * transaction object contains:
                 * businessDate - datestring; date the transactions are transacted (yyyy-MM-dd HH:mm:ss.S)
                 * lastUpdated - datestring; date the transaction object is last updated (yyyy-MM-dd HH:mm.ss.S)
                 * transactionAmount - int; total amount computed from the list of transactions per day
                 * dataName - string; name to be displayed for the data in the chart
                 * id - int; transaction object identifier
                 * transactionCount - int; total transaction count computed from the list of transactions per day
                 * countAverage - decimal; average of transactionCount
                 * amountAverage - decimal; average of transactionAmount
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getDailyTerminalSummary() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/terminal/dailySummary`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/terminal/dailySummary`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        try {
            const response = await Vue.axios.post(url, {}, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of terminal summary." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getLatestUpdatedTerminal(offset, limit) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/terminal/getLatestUpdatedTerminal`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/terminal/getLatestUpdatedTerminal`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString()
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of terminals." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    /**
     * Get transaction totals per week
     */
    async getDashboardSummary() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/dashboard/summary`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/dashboard/summary`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        try {
            const response = await Vue.axios.post(url, {}, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string;
                 * statusCode string; http status code
                 * transactionTotalsPerType - JSON object containing:
                 * EXPIRED - JSON object containing:
                 * percentage: double; number of percentage of expired transactions/total transactions of the day
                 * count: int; number of expired transactions of the day
                 * PAID - JSON object containing:
                 * percentage: double; number of percentage of paid transactions/total transactions of the day
                 * count: int; number of paid transactions of the day
                 * PENDING - JSON object containing:
                 * percentage: double; number of percentage of pending transactions/total transactions of the day
                 * count: int; number of pending transactions of the day
                 * POSTED - JSON object containing:
                 * percentage: double; number of percentage of posted transactions/total transactions of the day
                 * count: int; number of posted transactions of the day
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of summaries." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getTerminals(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/terminal/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/terminal/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            terminalId: query.terminalId ?? '',
            serialNum: query.serialNum ?? '',
            merchantId: query.merchantId ?? '',
            merchantName: query.merchantName ?? '',
            // storeAssociation: query.storeAssociation ?? '',

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of terminals." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getTickets(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/ticket/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/ticket/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            code: query.code ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of tickets." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createTerminal(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/terminal/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/terminal/create`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            terminalId: formData.terminalId,
            serialNum: formData.serialNum,
            model: formData.model,
            brandName: formData.brandName,
            tradeName: formData.tradeName,
            // type: formData.type ?? "",
            merchantId: formData.merchant?.merchantId ?? null, // Correctly access the merchantId
            merchantName: formData.merchant?.name ?? "", // Correctly access the merchantName
            storeAssociation: formData.storeAssociation ?? "",
            branch: formData.branch ? formData.branch.code ?? "" : "",
            // deviceType: formData.deviceType ? formData.deviceType.code ?? "" : "",
            paymentAgent: formData.paymentAgent ? formData.paymentAgent.code ?? null : null,
            assignedTo: formData.user ? formData.user.username ?? "" : "",
            network: formData.network ?? "",
            // location: formData.location ?? "",
            pandateEntryMode: formData.pandateEntryMode ?? "",
            currency: JSON.stringify(formData.currency) ?? "",
            // posterminalType: formData.posterminalType ?? "",
            bancnetAddress: formData.bancnetAddress ?? "",
            bancnetFixedFee: formData.bancnetFixedFee ?? null,
            bancnetMerchantSettlementBankCode: formData.bancnetMerchantSettlementBankCode ?? "",
            bancnetTerminalOwner: formData.bancnetTerminalOwner ?? "",
            bancnetTerminalCode: formData.bancnetTerminalCode ?? "",
            maximumAmount: formData.maximumAmount ?? null,
            pinEntryCapability: formData.pinEntryCapability ?? "",
            // posTerminalEntryCapability: formData.posTerminalEntryCapability ?? "",
            posConditionCode: formData.posConditionCode ?? "",
            bancnetConvenienceFee: formData.bancnetConvenienceFee ?? null,
            simNetwork: formData.simNetwork ?? "",
            simCardNumber: formData.simCardNumber ?? "",
            dateInstalled: formData.dateInstalled ? (formData.dateInstalled = undefined ? null : formData.dateInstalled) : null,
            installedBy: formData.installedBy ?? "",
            // ipAddress: formData.ipAddress ?? "",
            status: formData.status ?? "",
            emvContact: formData.emvContact ?? "",
            // cardNetworkUsed: formData.cardNetworkUsed ?? '',
            // motopaymentIndicator: formData.motopaymentIndicator ?? '',
            unattendedAcceptanceTerminalIndicator: formData.unattendedAcceptanceTerminalIndicator ?? '',
            cardHolderidmethod: formData.cardHolderidmethod ?? '',
            serviceDevelopmentField: formData.serviceDevelopmentField ?? '',
            password: formData.terminalPassword ?? '',
            terminalMonitoring: formData.terminalMonitoring ?? '',
            autoSettlement: formData.autoSettlementFlag,
            autoSettlementTime: formData.autoSettlementTime ?? '',
            termCapabilities: formData.termCapabilities ?? '',
            termAddCapabilities: formData.termAddCapabilities ?? '',
            termType: formData.termType ?? '',
            // terminalPort: formData.terminalPortNumber ?? '',
            printSaleReceipt: formData.printSaleReceipt,
            mode: formData.terminalMode ?? '',
            // mac: formData.terminalMacAddress ?? '',
            // merchants: JSON.stringify(formData.merchantAssociation) ?? {},
            batchIndex: formData.batchIndex ?? '',
            batchLimit: formData.batchLimit ?? '',
            batchNumber: formData.batchNumber ?? '',
            stan: formData.stan ?? '',
            cardSchemes: JSON.stringify(this.filterCardScheme(formData.cardScheme)) ?? {},
            emvs: JSON.stringify(this.filterEmv(formData.emv)) ?? {},
            isEnabled: formData.isEnabled,
            enableVoid: formData.enableVoid,
            voidPassword: formData.voidPassword,
            enableBalanceInquiry: formData.enableBalanceInquiry,
            enableCashout: formData.enableCashout,
            enableSale: formData.enableSale,
            enableRefund: formData.enableRefund,
            storeNumber: formData.storeNumber,
            posNumber: formData.posNumber,
            reversalRetry: formData.reversalRetry,
            terminalStatus: formData.terminalStatus
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error.response.data.message };
        }
    },

    async updateTerminal(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/terminal/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/terminal/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            terminalId: formData.terminalId,
            serialNum: formData.serialNum,
            model: formData.model,
            brandName: formData.brandName,
            tradeName: formData.tradeName,
            // type: formData.type ?? '',
            merchantId: formData.merchant?.merchantId ?? null, // Correctly access the merchantId
            merchantName: formData.merchant?.name ?? "", // Correctly access the merchantName
            storeAssociation: formData.storeAssociation ?? "",
            // branch: formData.branch ? formData.branch.code ?? "" : "",
            // deviceType: formData.deviceType ? formData.deviceType.code ?? "" : "",
            paymentAgent: formData.paymentAgent ? formData.paymentAgent.code ?? null : null,
            assignedTo: formData.user ? formData.user.username ?? "" : "",
            network: formData.network ?? "",
            // location: formData.location ?? '',
            pandateEntryMode: formData.pandateEntryMode ?? '',
            currency: JSON.stringify(formData.currency) ?? "",
            // posterminalType: formData.posterminalType ?? '',
            bancnetAddress: formData.bancnetAddress ?? '',
            bancnetFixedFee: formData.bancnetFixedFee ?? null,
            bancnetMerchantSettlementBankCode: formData.bancnetMerchantSettlementBankCode ?? '',
            bancnetTerminalOwner: formData.bancnetTerminalOwner ?? '',
            bancnetTerminalCode: formData.bancnetTerminalCode ?? '',
            maximumAmount: formData.maximumAmount ?? null,
            pinEntryCapability: formData.pinEntryCapability ?? '',
            // posTerminalEntryCapability: formData.posTerminalEntryCapability ?? '',
            posConditionCode: formData.posConditionCode ?? '',
            bancnetConvenienceFee: formData.bancnetConvenienceFee ?? null,
            simNetwork: formData.simNetwork ?? '',
            simCardNumber: formData.simCardNumber ?? '',
            dateInstalled: formData.dateInstalled ? (formData.dateInstalled = undefined ? null : formData.dateInstalled) : null,
            installedBy: formData.installedBy ?? '',
            // ipAddress: formData.ipAddress ?? '',
            status: formData.status ?? '',
            emvContact: formData.emvContact ?? "",
            // cardNetworkUsed: formData.cardNetworkUsed ?? '',
            // motopaymentIndicator: formData.motopaymentIndicator ?? '',
            unattendedAcceptanceTerminalIndicator: formData.unattendedAcceptanceTerminalIndicator ?? '',
            cardHolderidmethod: formData.cardHolderidmethod ?? '',
            serviceDevelopmentField: formData.serviceDevelopmentField ?? '',

            password: formData.terminalPassword ?? '',
            terminalMonitoring: formData.terminalMonitoring ?? '',
            autoSettlement: formData.autoSettlementFlag,
            autoSettlementTime: formData.autoSettlementTime ?? '',
            termCapabilities: formData.termCapabilities ?? '',
            termAddCapabilities: formData.termAddCapabilities ?? '',
            termType: formData.termType ?? '',
            // terminalPort: formData.terminalPortNumber ?? '',
            printSaleReceipt: formData.printSaleReceipt,
            enableVoid: formData.enableVoid,
            voidPassword: formData.voidPassword,
            enableBalanceInquiry: formData.enableBalanceInquiry,
            enableCashout: formData.enableCashout,
            enableSale: formData.enableSale,
            enableRefund: formData.enableRefund,

            mode: formData.terminalMode ?? '',
            // mac: formData.terminalMacAddress ?? '',
            // merchants: formData.merchantAssociation,
            batchIndex: formData.batchIndex ?? '',
            batchLimit: formData.batchLimit ?? '',
            batchNumber: formData.batchNumber ?? '',
            stan: formData.stan ?? '',
            cardSchemes: JSON.stringify(this.filterCardScheme(formData.cardScheme)) ?? {},
            emvs: JSON.stringify(this.filterEmv(formData.emv)) ?? {},
            isEnabled: formData.isEnabled,
            storeNumber: formData.storeNumber,
            posNumber: formData.posNumber,
            reversalRetry: formData.reversalRetry,
            terminalStatus: formData.terminalStatus
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error.response.data.message };
        }
    },

    async getNextTerminalId() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        let url = `${dashboardUrl}/terminal/getTerminalId`;
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/terminal/getTerminalId`;
        }

        const config = {
          headers: {
            'Authorization': `${router.app.$keycloak.token}`,
            'Content-Type': 'application/json'
          }
        };

        try {
          const response = await Vue.axios.get(url, config);
          if (response && response.status === 200 && response.data.terminalId) {
            return response.data.terminalId;
          } else {
            console.error("Unexpected response fetching next terminalId:", response);
            return null;
          }
        } catch (err) {
          console.error("Error fetching next terminalId:", err.response?.data || err);
          return null;
        }
    },

    filterCardScheme(cardScheme) {
        var value = cardScheme
            .filter(item => item.cardSchemeId !== '')
            .map(item => {
                // const { cardSchemeIndex, cardSchemeId } = item;
                const { cardSchemeId } = item;
                return {
                    // cardSchemeIndex: cardSchemeIndex,
                    cardSchemeId: cardSchemeId,
                };
            });
        console.log(value)
        return value
    },
    filterEmv(emv) {
        var value = emv
            .filter(item => item.schemeReference !== '')
            .map(item => {
                // const { emvId, schemeReference } = item;
                const { schemeReference } = item;
                return {
                    // emvId: emvId,
                    schemeReference: schemeReference,
                };
            });
        console.log(value)
        return value
    },

    async updateTicket(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/ticket/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/ticket/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            code: formData.code,
            issue: formData.issue,
            terminalId: formData.terminalId,
            terminalId: formData.terminalId ? formData.terminalId.terminalId ?? "" : "",
            reportedBy: formData.reportedBy ? formData.reportedBy.username ?? "" : "",
            assignedTo: formData.assignedTo ? formData.assignedTo.username ?? "" : "",
            status: formData.status,
            action: formData.action,
            partsReplaced: formData.partsReplaced,
            serviceSchedule: formData.serviceSchedule,
            dateResolved: formData.dateResolved,
            problem: formData.problem,
            ecodAction: formData.ecodAction,
            remarks: formData.remarks,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async updateStoreIp(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/storeIp/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/ticket/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: formData.id,
            store: formData.store,
            ipAddress: formData.ipAddress,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async updateMerchantCommission(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchantCommission/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/merchantCommission/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: formData.id ?? null,
            merchantId: formData.merchant ? formData.merchant.id ?? null : null,
            productName: formData.productName ?? '',
            percentCommission: formData.percentCommission ?? null,
            fixedCommission: formData.fixedCommission ?? null,
            itPercentCommission: formData.providerPercentCommission ?? null,
            itFixedCommission: formData.providerFixedCommission ?? null,
            applicationDate: formData.applicationDate ?? null,

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async disableStoreIp(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/storeIp/disable`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/ticket/disable`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: formData.id,
            store: formData.store,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async enableStoreIp(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/storeIp/enable`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/ticket/enable`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: formData.id,
            store: formData.store,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
      * Get list of TDM Branches
      */
    async getAllBranches() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/branch/listBranches`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/branch/listBranches`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of branches." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getBranches(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/searchBranch`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/searchBranch`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            code: query.code ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of branches." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getStoreIps(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/storeIp/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/storeIp/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            store: query.store ?? '',
            ipAddress: query.ipAddress ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of store Ips." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getMerchantCommissions(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchantCommission/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/merchantCommission/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            merchantId: query.merchant ? query.merchant.id ?? null : null,
            productName: query.productName ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of store Ips." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    // async getAllDeviceTypes() {
    //     /**Use when CORS issue is resolved, directly communicate to server without proxy*/
    //     var url = `${dashboardUrl}/deviceType/listDeviceTypes`
    //     if (isProxy) {
    //         /**Use when CORS issue persists, and use proxy*/
    //         url = `/tdm/deviceType/listDeviceTypes`
    //     }
    //     const config = {
    //         headers: {
    //             Authorization: `${router.app.$keycloak.token}`
    //         }
    //     }
    //     const body = {
    //     }

    //     try {
    //         const response = await Vue.axios.post(url, body, config);
    //         console.log(response);
    //         if (response && response.data && response.status == 200) {
    //             return response.data;
    //         } else if (response && response.data && response.data.message) {
    //             return { error: response.data.message };
    //         } else {
    //             return { error: "Sorry. Error getting list of all device types." };
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         return this.getError(error)
    //     }
    // },

    async getDeviceTypes(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/deviceType/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/deviceType/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            code: query.code ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of device types." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async testDownloadReport(reportType) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/download`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/download`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`
            },
            responseType: 'blob',
            timeout: 120000,
        }

        if (reportType == null || reportType == '') {
            reportType = 'CSV'
        }
        var fileName = 'terminals.' + reportType.toLowerCase()
        const body = {
            format: reportType,
            fileLocation: `${fileName}`
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (fileNameMatch.length === 2)
                        fileName = fileNameMatch[1];
                }
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error downloading report." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getPaymentAgents(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/paymentAgent/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/paymentAgent/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            code: query.code ?? '',
            name: query.name ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payment agents." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllPaymentAgents() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/paymentAgent/listPaymentAgents`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/paymentAgent/listPaymentAgents`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of all payment agents." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllTerminals() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/terminal/listTerminals`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/terminal/listTerminals`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log('getAllTerminals: ', response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of all terminals." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createBranch(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/registerBranch`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/registerBranch`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            code: parameters.code,
            name: parameters.name,
            address: parameters.address,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating branch." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createDeviceType(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/deviceType/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/deviceType/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            code: parameters.code,
            name: parameters.name,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating device type." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createTicket(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/ticket/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/ticket/create`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            code: formData.code,
            issue: formData.issue,
            terminalId: formData.terminalId,
            terminalId: formData.terminalId ? formData.terminalId.terminalId ?? "" : "",
            reportedBy: formData.reportedBy ? formData.reportedBy.username ?? "" : "",
            assignedTo: formData.assignedTo ? formData.assignedTo.username ?? "" : "",
            status: formData.status,
            action: formData.action,
            partsReplaced: formData.partsReplaced,
            serviceSchedule: formData.serviceSchedule,
            dateResolved: formData.dateResolved,
            problem: formData.problem,
            ecodAction: formData.ecodAction,
            remarks: formData.remarks,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async createStoreIp(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/storeIp/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/storeIp/create`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            store: formData.store,
            ipAddress: formData.ipAddress
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async createMerchantCommission(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchantCommission/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/merchantCommission/create`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantId: formData.merchant ? formData.merchant.id ?? null : null,
            productName: formData.productName ?? '',
            percentCommission: formData.percentCommission ?? null,
            fixedCommission: formData.fixedCommission ?? null,
            itPercentCommission: formData.providerPercentCommission ?? null,
            itFixedCommission: formData.providerFixedCommission ?? null,
            applicationDate: formData.applicationDate ?? null,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async createPaymentAgent(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/paymentAgent/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/paymentAgent/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            code: parameters.code,
            name: parameters.name,
            mobileNumber: parameters.mobileNumber,
            email: parameters.email,
            isEnabled: parameters.isEnabled,
            merchants: parameters.merchants,
            remarks: parameters.remarks,
            qrEnabled: parameters.qrEnabled,
            baseUrl: parameters.baseUrl,
            userName: parameters.userName,
            passWord: parameters.passWord
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating payment agent." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateBranch(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/updateBranch`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/updateBranch`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            code: parameters.code,
            name: parameters.name,
            address: parameters.address
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating branch." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateDeviceType(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/deviceType/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/deviceType/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            code: parameters.code,
            name: parameters.name,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating device type." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updatePaymentAgent(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/paymentAgent/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/paymentAgent/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            code: parameters.code,
            name: parameters.name,
            mobileNumber: parameters.mobileNumber,
            email: parameters.email,
            isEnabled: parameters.isEnabled,
            merchants: parameters.merchants,
            remarks: parameters.remarks,
            qrEnabled: parameters.qrEnabled,
            baseUrl: parameters.baseUrl,
            userName: parameters.userName,
            passWord: parameters.passWord
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating payment agent." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    /**
     * Get list of TDM Users
     */
    async getAllAssignedToUsers() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/listAssignedToUsers`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/user/listAssignedToUsers`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            },
            timeout: 200000
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of roles." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    /**
    * Get list of TDM Merchants
    */
    async getMerchants() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchant/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    /**
     * Get unmatched store count totals daily
     */
    async getTopUnmatchedStoresCount() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/dashboard/topUnmatchedStores`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/dashboard/topUnmatchedStores`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            limit: 10,
            type: 'count'
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string;
                 * statusCode string; http status code
                 * transactionTotalsPerType - JSON object containing:
                 * EXPIRED - JSON object containing:
                 * percentage: double; number of percentage of expired transactions/total transactions of the day
                 * count: int; number of expired transactions of the day
                 * PAID - JSON object containing:
                 * percentage: double; number of percentage of paid transactions/total transactions of the day
                 * count: int; number of paid transactions of the day
                 * PENDING - JSON object containing:
                 * percentage: double; number of percentage of pending transactions/total transactions of the day
                 * count: int; number of pending transactions of the day
                 * POSTED - JSON object containing:
                 * percentage: double; number of percentage of posted transactions/total transactions of the day
                 * count: int; number of posted transactions of the day
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of stores." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
     * Get unmatched store amount totals daily
     */
    async getTopUnmatchedStoresAmount() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/dashboard/topUnmatchedStores`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/dashboard/topUnmatchedStores`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            limit: 10,
            type: 'amount'
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string;
                 * statusCode string; http status code
                 * transactionTotalsPerType - JSON object containing:
                 * EXPIRED - JSON object containing:
                 * percentage: double; number of percentage of expired transactions/total transactions of the day
                 * count: int; number of expired transactions of the day
                 * PAID - JSON object containing:
                 * percentage: double; number of percentage of paid transactions/total transactions of the day
                 * count: int; number of paid transactions of the day
                 * PENDING - JSON object containing:
                 * percentage: double; number of percentage of pending transactions/total transactions of the day
                 * count: int; number of pending transactions of the day
                 * POSTED - JSON object containing:
                 * percentage: double; number of percentage of posted transactions/total transactions of the day
                 * count: int; number of posted transactions of the day
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of stores." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
     * Get details of a specific transaction
     */
    async getTransactionDetails(transactionId) {

    },

    /**
     * Filter list of transactions based on the parameters
     * parameters: JSON object containing:
     * offset: int or empty string;
     * limit: int or empty string;
     * payId: string or empty string;
     * merchantId: string or empty string;
     * merchantRef: string or empty string;
     * storeId: string or empty string;
     * storeName: string or empty string;
     * posReference: string or empty string;
     * dateFrom: datestring or empty string;
     * dateTo: datestring or empty string;
     */
    async getUnmatchedTransaction(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/transaction/searchUnmatched`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/transaction/searchUnmatched`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            payId: parameters.payId,
            merchantId: parameters.merchantId,
            merchantRef: parameters.merchantRef,
            storeId: parameters.storeId,
            storeName: parameters.storeName,
            posReference: parameters.posReference,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http cpde
                 * transactions - JSON array of transaction objects
                 * transaction object contains:
                 * expiryDate - datestring; date the transaction will expire
                 * amount - decimal; transaction amount
                 * serviceCharge - decimal; transaction service charge
                 * dateCreated - datestring; date the transaction is created
                 * merchantReferenceNo - string; merchant reference number
                 * merchant - string; merchantId
                 * id - int; transaction identifier
                 * paymentStatus - string; status of transaction
                 * sevenPayID - string; payconnect reference number
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
     * Filter list of transactions based on the parameters
     * parameters: JSON object containing:
     * offset: int or empty string;
     * limit: int or empty string;
     * payId: string or empty string;
     * merchantId: string or empty string;
     * merchantRef: string or empty string;
     * storeId: string or empty string;
     * storeName: string or empty string;
     * posReference: string or empty string;
     * dateFrom: datestring or empty string;
     * dateTo: datestring or empty string;
     */
    async getTransactions(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/transaction/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/transaction/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            terminalId: parameters.terminalId,
            merchantId: parameters.merchantId,
            merchantCode: parameters.merchantCode,
            primaryAccountNumber: parameters.primaryAccountNumber,
            acquirerReferenceNumber: parameters.acquirerReferenceNumber,
            retrievalReferenceNumber: parameters.retrievalReferenceNumber,
            systemTraceAuditNumber: parameters.systemTraceAuditNumber,
            transactionType: parameters.transactionType,
            processingCode: parameters.processingCode,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http cpde
                 * transactions - JSON array of transaction objects
                 * transaction object contains:
                 * expiryDate - datestring; date the transaction will expire
                 * amount - decimal; transaction amount
                 * serviceCharge - decimal; transaction service charge
                 * dateCreated - datestring; date the transaction is created
                 * merchantReferenceNo - string; merchant reference number
                 * merchant - string; merchantId
                 * id - int; transaction identifier
                 * paymentStatus - string; status of transaction
                 * sevenPayID - string; payconnect reference number
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getCashOutTransactions(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/transaction/searchCashOut`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/transaction/searchCashOut`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            terminalId: parameters.terminalId,
            merchantId: parameters.merchantId,
            primaryAccountNumber: parameters.primaryAccountNumber,
            acquirerReferenceNumber: parameters.acquirerReferenceNumber,
            retrievalReferenceNumber: parameters.retrievalReferenceNumber,
            systemTraceAuditNumber: parameters.systemTraceAuditNumber,
            transactionType: parameters.transactionType,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http cpde
                 * transactions - JSON array of transaction objects
                 * transaction object contains:
                 * expiryDate - datestring; date the transaction will expire
                 * amount - decimal; transaction amount
                 * serviceCharge - decimal; transaction service charge
                 * dateCreated - datestring; date the transaction is created
                 * merchantReferenceNo - string; merchant reference number
                 * merchant - string; merchantId
                 * id - int; transaction identifier
                 * paymentStatus - string; status of transaction
                 * sevenPayID - string; payconnect reference number
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getInstapayOutwardTransactions(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/transaction/searchOutwardTransactions`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/transaction/searchOutwardTransactions`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            partnerId: parameters.partnerId,
            partnerMerchantId: parameters.partnerMerchantId,
            lclInstrm: parameters.lclInstrm,
            clientId: parameters.clientId,
            instrId: parameters.instrId,
            msgId: parameters.msgId,
            txId: parameters.txId,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getAuditLog(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/auditLog/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/auditLog/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            user: parameters.user,
            controller: parameters.controller,
            action: parameters.action,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http cpde
                 * transactions - JSON array of transaction objects
                 * transaction object contains:
                 * expiryDate - datestring; date the transaction will expire
                 * amount - decimal; transaction amount
                 * serviceCharge - decimal; transaction service charge
                 * dateCreated - datestring; date the transaction is created
                 * merchantReferenceNo - string; merchant reference number
                 * merchant - string; merchantId
                 * id - int; transaction identifier
                 * paymentStatus - string; status of transaction
                 * sevenPayID - string; payconnect reference number
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getThresholds(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            type: query.type ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllMerchants() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/listMerchants`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/listMerchants`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: 0,
            pageSize: 0,
            name: ''
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllCountries() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchant/listCountries`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/listCountries`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: 0,
            pageSize: 0,
            name: ''
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of countries." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllMerchantCategoryCodes() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchant/listMerchantCategoryCodes`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/listMerchantCategoryCodes`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: 0,
            pageSize: 0,
            name: ''
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchant category codes." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllBranchNameList() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchant/listBranchNames`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/listBranchNames`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: 0,
            pageSize: 0,
            name: ''
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Branch Names." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getFilteredMerchants() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/listFiltered`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/listFiltered`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: 0,
            pageSize: 0,
            name: ''
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of filtered merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createThreshold(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            type: parameters.type,
            count: parameters.count,
            amount: parameters.amount,
            remarks: parameters.remarks,
            isEnabled: parameters.isEnabled

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating threshold." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateThreshold(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            type: parameters.type,
            count: parameters.count,
            amount: parameters.amount,
            remarks: parameters.remarks,
            isEnabled: parameters.isEnabled
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating threshold." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateMerchantFilter(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/updateFiltered`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/updateFiltered`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            merchantFilters: parameters.merchants
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating threshold." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getDisabledStores(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/listDisabled`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/listDisabled`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            storeNo: query.storeNo ?? '',
            storeName: query.storeName ?? '',
            dateFrom: query.dateFrom ?? '',
            dateTo: query.dateTo ?? ''
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of disabled stores." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async enableStore(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/threshold/enableStore`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/threshold/enableStore`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            id: parameters.id,
            storeNo: parameters.storeNo,
            storeName: parameters.storeName
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error enabling store." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getStoreEventLog(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/store/searchEventLog`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/store/searchEventLog`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            storeNo: query.storeNo ?? '',
            storeName: query.storeName ?? '',
            remarks: query.remarks ?? '',
            dateCreatedFrom: query.dateFrom ?? '',
            dateCreatedTo: query.dateTo ?? ''
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of stores event logs." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    /**
     * Filter list of transactions based on the parameters
     * parameters: JSON object containing:
     * offset: int or empty string;
     * limit: int or empty string;
     * payId: string or empty string;
     * merchantId: string or empty string;
     * merchantRef: string or empty string;
     * storeId: string or empty string;
     * storeName: string or empty string;
     * posReference: string or empty string;
     * dateFrom: datestring or empty string;
     * dateTo: datestring or empty string;
     */
    async searchMerchants(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchant/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            name: parameters.name,
            mobileNumber: parameters.mobileNumber,
            email: parameters.email,
            merchantId: parameters.merchantId,
            merchantCode: parameters.merchantCode,
            enabled: parameters.enabled,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http cpde
                 * transactions - JSON array of transaction objects
                 * transaction object contains:
                 * expiryDate - datestring; date the transaction will expire
                 * amount - decimal; transaction amount
                 * serviceCharge - decimal; transaction service charge
                 * dateCreated - datestring; date the transaction is created
                 * merchantReferenceNo - string; merchant reference number
                 * merchant - string; merchantId
                 * id - int; transaction identifier
                 * paymentStatus - string; status of transaction
                 * sevenPayID - string; payconnect reference number
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async createMerchant(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchant/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/create`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantName: formData.name,
            legalName: formData.legalName ?? "",
            legalForm: formData.legalForm ?? "",
            distributionOfFees: formData.distributionOfFees ?? "0",
            fixedDiscountRate: formData.fixedDiscountRate ?? "0", // visa fixed fee
            discountRateDebit: formData.discountRateDebit ?? "0", // bancnet percentage
            fixedDiscountRateDebit: formData.fixedDiscountRateDebit ?? "0", // bancnet fixed fee
            discountRate: formData.discountRate ?? "0", // visa percentage
            merchantAddress: formData.merchantAddress ?? "",
            tradeName: formData.tradeName ?? "",
            companyName: formData.companyName ?? "",
            clientNumber: formData.clientNumber ?? "",
            primaryContactEmail: formData.primaryContactEmail ?? "",
            primaryContactNumber: formData.primaryContactNumber ?? "",
            secondaryContactEmail: formData.secondaryContactEmail ?? "",
            secondaryContactNumber: formData.secondaryContactNumber ?? "",
            branchNameList: formData.branchNameList ?? "",
            branchContactPerson: formData.branchContactPerson ?? "",
            branchContactNumber: formData.branchContactNumber ?? "",
            branchEmailAddress: formData.branchEmailAddress ?? "",
            serviceFee: formData.serviceFee ?? "0",
            fixedFee: formData.fixedFee ?? "0",
            tinNumber: formData.tinNumber ?? "",
            postalCode: formData.postalCode ?? "",
            city: formData.city,
            state: formData.state ?? "",
            province: formData.province ?? "",
            country: formData.country ? formData.country.numCode ?? "" : "",
            comments: formData.comments ?? "",
            merchantVerificationValue: formData.merchantVerificationValue ?? "",
            paymentAgentCode: formData.paymentAgent ? formData.paymentAgent.code ?? null : null,
            merchantCategoryCode: formData.merchantCategoryCode ? formData.merchantCategoryCode.description ?? "" : "",
            enabled: formData.enabled,
            mvv: formData.mvv,
            // acquirerId: formData.acquirerId,
            withholdingTaxRate: formData.withholdingTaxRate ?? "0",
            pscWithholdingTaxRate: formData.pscWithholdingTaxRate ?? "0",
            minimumAmount: formData.minimumAmount ?? "0",
            maximumAmount: formData.maximumAmount ?? "0",
            averageAmount: formData.averageAmount ?? "0",
            holdOutRate: formData.holdOutRate ?? "0",
            passDiscountRate: formData.passDiscountRate,
            discountRate: formData.discountRate ?? "0",
            passFlatFee: formData.passFlatFee,
            bancnetFlatFee: formData.bancnetFlatFee ?? "0",
            cashoutIncome: formData.cashoutIncome ?? "0",
            cashoutShare: formData.cashoutShare ?? "0",
            serviceFeeLabel: formData.serviceFeeLabel ?? "",
            purchaseIdentifierFormat: formData.purchaseIdentifierFormat ?? "",
            isAsymmetricKeyEnabled: formData.isAsymmetricKeyEnabled,
            footer1: formData.footer1,
            footer2: formData.footer2,
            footer3: formData.footer3,
            branchAccountNumber: formData.branchAccountNumber ?? "",
            depositoryBankName: formData.depositoryBankName ?? "",
            depositoryBankAccountName: formData.depositoryBankAccountName ?? "",
            depositoryBankAccount: formData.depositoryBankAccount ?? "",
            depositoryBankNameUSD: formData.depositoryBankNameUSD ?? "",
            depositoryBankAccountNameUSD: formData.depositoryBankAccountNameUSD ?? "",
            depositoryBankAccountUSD: formData.depositoryBankAccountUSD ?? "",
            principalContactPerson: formData.principalContactPerson ?? "",
            alternateContactPerson: formData.alternateContactPerson ?? "",
            telephoneNumber: formData.telephoneNumber ?? "",
            mobileNumber: formData.mobileNumber ?? "",
            faxNumber: formData.faxNumber ?? "",
            website: formData.website ?? "",
            email: formData.email ?? "",
            authFee: formData.authFee ?? "0",
            chargebackFee: formData.chargebackFee ?? "0",
            monthlyAccessFee: formData.monthlyAccessFee ?? "0",
            refundFee: formData.refundFee ?? "0",
            retrievalFee: formData.retrievalFee ?? "0",
            voiceAuthFee: formData.voiceAuthFee ?? "0",
            settlementFee: formData.settlementFee ?? "0",
            merchantId: formData.merchantId,
            merchantIdList: JSON.stringify(formData.merchantIdList),
            merchantCode: formData.merchantCode,
            storeAssociation: formData.storeAssociation,
            expireAfter: formData.expireAfter ?? "2880",
            validatePayconnect: formData.validatePayconnect,
            stip: formData.stip,
            amountEditable: formData.amountEditable,
            merchantLogoUrl: formData.merchantLogoUrl ?? "",
            isMultipleBiller: formData.isMultipleBiller,
            allowWalletPayment: formData.allowWalletPayment,
            isMobileNumberRequired: formData.isMobileNumberRequired,
            hasPriceAdjustment: formData.hasPriceAdjustment,
            endpointUrl: formData.endpointUrl ?? "",
            connectTimeout: formData.connectTimeout ?? "3000",
            readTimeout: formData.readTimeout ?? "10000",
            randomizeRefNum: formData.randomizeRefNum,
            referenceReusable: formData.referenceReusable,
            accountCode: formData.accountCode ?? "",
            branchCode: formData.branchCode ?? "",
            accountUsername: formData.accountUsername ?? "",
            accountUsercode: formData.accountUsercode ?? "",
            accountPassword: formData.accountPassword ?? ""
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                  * Response.data - JSON object and contains:
                  * message - string
                  * statusCode - string; http status code
                  */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                  * Response.data JSON object and contains:
                  * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                  * status - int; http status code; optional response
                  * statusCode - string; http status codel optional response
                  * message - string; always
                  * expired - boolean; optional response
                  */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
              * Exception error
              */
            console.log(error);
            return { error: error };
        }
    },

    async updateMerchant(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/merchant/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: formData.id,
            merchantName: formData.name,
            legalName: formData.legalName ?? "",
            legalForm: formData.legalForm ?? "",
            distributionOfFees: formData.distributionOfFees ?? "0",
            fixedDiscountRate: formData.fixedDiscountRate ?? "0", // visa fixed fee
            discountRateDebit: formData.discountRateDebit ?? "0", // bancnet percentage
            fixedDiscountRateDebit: formData.fixedDiscountRateDebit ?? "0", // bancnet fixed fee
            discountRate: formData.discountRate ?? "0", // visa percentage
            merchantAddress: formData.merchantAddress ?? "",
            tradeName: formData.tradeName ?? "",
            companyName: formData.companyName ?? "",
            clientNumber: formData.clientNumber ?? "",
            primaryContactEmail: formData.primaryContactEmail ?? "",
            primaryContactNumber: formData.primaryContactNumber ?? "",
            secondaryContactEmail: formData.secondaryContactEmail ?? "",
            secondaryContactNumber: formData.secondaryContactNumber ?? "",
            branchNameList: formData.branchNameList ?? "",
            branchContactPerson: formData.branchContactPerson ?? "",
            branchContactNumber: formData.branchContactNumber ?? "",
            branchEmailAddress: formData.branchEmailAddress ?? "",
            serviceFee: formData.serviceFee ?? "0",
            fixedFee: formData.fixedFee ?? "0",
            tinNumber: formData.tinNumber ?? "",
            postalCode: formData.postalCode ?? "",
            city: formData.city,
            state: formData.state ?? "",
            province: formData.province ?? "",
            country: formData.country ? formData.country.numCode ?? "" : "",
            comments: formData.comments ?? "",
            merchantVerificationValue: formData.merchantVerificationValue ?? "",
            paymentAgentCode: formData.paymentAgent ? formData.paymentAgent.code ?? null : null,
            merchantCategoryCode: formData.merchantCategoryCode ? formData.merchantCategoryCode.description ?? "" : "",
            enabled: formData.enabled,
            mvv: formData.mvv,
            // acquirerId: formData.acquirerId,
            pscWithholdingTaxRate: formData.pscWithholdingTaxRate ?? "0",
            withholdingTaxRate: formData.withholdingTaxRate ?? "0",
            minimumAmount: formData.minimumAmount ?? "0",
            maximumAmount: formData.maximumAmount ?? "0",
            averageAmount: formData.averageAmount ?? "0",
            holdOutRate: formData.holdOutRate ?? "0",
            passDiscountRate: formData.passDiscountRate,
            discountRate: formData.discountRate ?? "0",
            passFlatFee: formData.passFlatFee,
            bancnetFlatFee: formData.bancnetFlatFee ?? "0",
            cashoutIncome: formData.cashoutIncome ?? "0",
            cashoutShare: formData.cashoutShare ?? "0",
            serviceFeeLabel: formData.serviceFeeLabel ?? "",
            purchaseIdentifierFormat: formData.purchaseIdentifierFormat ?? "",
            isAsymmetricKeyEnabled: formData.isAsymmetricKeyEnabled,
            footer1: formData.footer1 ?? "",
            footer2: formData.footer2 ?? "",
            footer3: formData.footer3 ?? "",
            branchAccountNumber: formData.branchAccountNumber ?? "",
            depositoryBankName: formData.depositoryBankName ?? "",
            depositoryBankAccountName: formData.depositoryBankAccountName ?? "",
            depositoryBankAccount: formData.depositoryBankAccount ?? "",
            depositoryBankNameUSD: formData.depositoryBankNameUSD ?? "",
            depositoryBankAccountNameUSD: formData.depositoryBankAccountNameUSD ?? "",
            depositoryBankAccountUSD: formData.depositoryBankAccountUSD ?? "",
            principalContactPerson: formData.principalContactPerson ?? "",
            alternateContactPerson: formData.alternateContactPerson ?? "",
            telephoneNumber: formData.telephoneNumber ?? "",
            mobileNumber: formData.mobileNumber ?? "",
            faxNumber: formData.faxNumber ?? "",
            website: formData.website ?? "",
            email: formData.email ?? "",
            authFee: formData.authFee ?? "0",
            chargebackFee: formData.chargebackFee ?? "0",
            monthlyAccessFee: formData.monthlyAccessFee ?? "0",
            refundFee: formData.refundFee ?? "0",
            retrievalFee: formData.retrievalFee ?? "0",
            voiceAuthFee: formData.voiceAuthFee ?? "0",
            settlementFee: formData.settlementFee ?? "0",
            merchantId: formData.merchantId,
            merchantIdList: JSON.stringify(formData.merchantIdList),
            merchantCode: formData.merchantCode,
            storeAssociation: formData.storeAssociation,
            expireAfter: formData.expireAfter ?? "2880",
            validatePayconnect: formData.validatePayconnect,
            stip: formData.stip,
            amountEditable: formData.amountEditable,
            merchantLogoUrl: formData.merchantLogoUrl ?? "",
            isMultipleBiller: formData.isMultipleBiller,
            allowWalletPayment: formData.allowWalletPayment,
            isMobileNumberRequired: formData.isMobileNumberRequired,
            hasPriceAdjustment: formData.hasPriceAdjustment,
            endpointUrl: formData.endpointUrl ?? "",
            connectTimeout: formData.connectTimeout ?? "3000",
            readTimeout: formData.readTimeout ?? "10000",
            randomizeRefNum: formData.randomizeRefNum,
            referenceReusable: formData.referenceReusable,
            accountCode: formData.accountCode ?? "",
            branchCode: formData.branchCode ?? "",
            accountUsername: formData.accountUsername ?? "",
            accountUsercode: formData.accountUsercode ?? "",
            accountPassword: formData.accountPassword ?? ""
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                  * Response.data - JSON object and contains:
                  * message - string
                  * statusCode - string; http status code
                  */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                  * Response.data JSON object and contains:
                  * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                  * status - int; http status code; optional response
                  * statusCode - string; http status codel optional response
                  * message - string; always
                  * expired - boolean; optional response
                  */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
              * Exception error
              */
            console.log(error);
            return { error: error };
        }
    },

    async saveMerchantConfig(payload) {
        var url = `${dashboardUrl}/merchant/saveConfig`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/merchant/saveConfig`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantId: payload.merchantId,
            username: payload.username
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {

                return { error: response.data.message };
            }
        } catch (error) {

            console.log(error);
            return { error: error };
        }
    },

    async getGroupMerchants(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/groupMerchant/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/groupMerchant/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            name: query.name ?? '',
            remarks: query.remarks ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchant groups." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createGroupMerchant(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/groupMerchant/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/createGroupMerchant/create`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            name: formData.name,
            remarks: formData.remarks,
            merchants: formData.merchants,
            users: formData.users,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async updateGroupMerchant(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/groupMerchant/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/groupMerchant/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: formData.id,
            name: formData.name,
            remarks: formData.remarks,
            merchants: formData.merchants,
            users: formData.users,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
     * Get total amounts and transaction count of transactions per day for Admin Users
     */
    async getTransactionsTotal(limit = 10, offset = 0) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/transaction/pastSummary`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `transaction/pastSummary`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * dashboardTotals - JSON array of transaction objects
                 * transaction object contains:
                 * businessDate - datestring; date the transactions are transacted (yyyy-MM-dd HH:mm:ss.S)
                 * lastUpdated - datestring; date the transaction object is last updated (yyyy-MM-dd HH:mm.ss.S)
                 * transactionAmount - int; total amount computed from the list of transactions per day
                 * dataName - string; name to be displayed for the data in the chart
                 * id - int; transaction object identifier
                 * transactionCount - int; total transaction count computed from the list of transactions per day
                 * countAverage - decimal; average of transactionCount
                 * amountAverage - decimal; average of transactionAmount
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    getError(error) {
        if (error && error.response && error.response.data) {
            console.log(error.response)
            if (error.response.data.message) {
                return { error: error.response.data.message + "" };
            } else if (error.response.data.error) {
                return { error: error.response.data.error + "" };
            } else {
                return { error: error.response.data + "" };
            }
        } else {
            return { error: error + "" };
        }
    },

    async updatePassword(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/user/updatePassword`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/user/updatePassword`
        }
        const user = `${formData.user}:${formData.password}:${formData.newPassword}`
        //  console.log(user);
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'user': `${btoa(user)}`,
                'Content-Type': 'application/json'
            }
        }
        const body = ""
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async getDatePasswordUpdate(user) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/userManagement/checkPasswordDate`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/switch/userManagement/checkPasswordDate`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            username: user
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting passwod details." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async searchBills(offset, limit, parameters, transactionStatus) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${billingSytemPath}/api/bill/search_filter?page=${offset}&size=${limit}`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/biller/api/bill/search_filter?page=${offset}&size=${limit}`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            accountNumber: parameters.accountNumber,
            billingNumber: parameters.billingNumber,
            accountName: parameters.accountName,
            startIssueDate: parameters.startIssueDate === '' ? "0000-00-00" : parameters.startIssueDate,
            endIssueDate: parameters.endIssueDate === '' ? new Date().toISOString().slice(0, 10) : parameters.endIssueDate,
            startDueDate: parameters.startDueDate === '' ? "0000-00-00" : parameters.startDueDate,
            endDueDate: parameters.endDueDate === '' ? new Date().toISOString().slice(0, 10) : parameters.endDueDate,
            status: transactionStatus,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async uploadFile(apiURL, formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = apiURL
        // if(isProxy) {
        //   /**Use when CORS issue persists, and use proxy*/
        //   url = `/tdm/bill/search_filter?page=0&size=10`
        // }
        const config = {
            headers: {
                // Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'multipart/form-data'
            }
        }
        try {
            const response = await Vue.axios.post(url, formData, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error in Send File." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    async getMerchantCode() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantMapping/getMerchantCodes`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantMapping/getMerchantCodes`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        try {
            const response = await Vue.axios.get(url, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants code." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },


    async getMatchedTransactions(matchedTransaction) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/matchedTransaction/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/matchedTransaction/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            },
            timeout: 200000,
        }
        const body = {
            merchantCode: matchedTransaction.merchantCode ?? "",
            payconnectReference: matchedTransaction.payconnectReference ?? "",
            merchantReference: matchedTransaction.merchantReference ?? "",
            dateFrom: matchedTransaction.dateFrom ?? "",
            dateTo: matchedTransaction.dateTo ?? "",
            isSettled: matchedTransaction.isSettled ?? false,
            pageNo: matchedTransaction.pageNo,
            pageSize: matchedTransaction.pageSize
        }
        console.log(body)
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of matched transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    //UNMATCHED TRANSACTION
    async getMerchantTransactions(merchantTransaction) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantTransaction/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantTransaction/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: merchantTransaction.merchantCode ?? "",
            payconnectReference: merchantTransaction.payconnectReference ?? "",
            merchantReference: merchantTransaction.merchantReference ?? "",
            dateFrom: merchantTransaction.dateFrom ?? "",
            dateTo: merchantTransaction.dateTo ?? "",
            pageNo: merchantTransaction.pageNo,
            pageSize: merchantTransaction.pageSize,
            isDeclined: false
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchant transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getDeclinedTransaction(declinedTransaction) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantTransaction/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantTransaction/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: declinedTransaction.merchantCode ?? "",
            payconnectReference: declinedTransaction.payconnectReference ?? "",
            merchantReference: declinedTransaction.merchantReference ?? "",
            dateFrom: declinedTransaction.dateFrom ?? "",
            dateTo: declinedTransaction.dateTo ?? "",
            pageNo: declinedTransaction.pageNo,
            pageSize: declinedTransaction.pageSize,
            isDeclined: true
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchant transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    async getPayconnectTransactions(payconnectTransaction) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/payconnectTransaction/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/payconnectTransaction/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: payconnectTransaction.merchantCode ?? "",
            payconnectReference: payconnectTransaction.payconnectReference ?? "",
            merchantReference: payconnectTransaction.merchantReference ?? "",
            dateFrom: payconnectTransaction.dateFrom ?? "",
            dateTo: payconnectTransaction.dateTo ?? "",
            pageNo: payconnectTransaction.pageNo,
            pageSize: payconnectTransaction.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    /**
     * Filter list of transactions based on the parameters
     * parameters: JSON object containing:
     * offset: int or empty string;
     * limit: int or empty string;
     * payId: string or empty string;
     * merchantId: string or empty string;
     * merchantRef: string or empty string;
     * storeId: string or empty string;
     * storeName: string or empty string;
     * posReference: string or empty string;
     * dateFrom: datestring or empty string;
     * dateTo: datestring or empty string;
     */
    async getBillerAccounts(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${billingSystemUrl}/api/account/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/biller/api/account/search`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            accountName: parameters.accountName ?? '',
            number: parameters.number ?? '',
            referenceNumber: parameters.referenceNumber ?? '',
            subscriptionPlan: parameters.subscriptionPlan ?? '',
            billerId: parameters.billerId ?? '',
            statusId: parameters.statusId ?? '',
            dateFrom: parameters.dateFrom ?? '',
            dateTo: parameters.dateTo ?? ''
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http cpde
                 * transactions - JSON array of transaction objects
                 * transaction object contains:
                 * expiryDate - datestring; date the transaction will expire
                 * amount - decimal; transaction amount
                 * serviceCharge - decimal; transaction service charge
                 * dateCreated - datestring; date the transaction is created
                 * merchantReferenceNo - string; merchant reference number
                 * merchant - string; merchantId
                 * id - int; transaction identifier
                 * paymentStatus - string; status of transaction
                 * sevenPayID - string; payconnect reference number
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    /**
    * Get list of Biller Account Status
    */
    async getStatusList() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${billingSystemUrl}/api/account/listStatus`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/biller/api/account/listStatus`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }

        try {
            const response = await Vue.axios.get(url, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    //PAYMENT AGENT MAPPING
    async getPaymentAgentMerchant(paymentAgentMerchant) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/paymentAgentMapping/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/paymentAgentMapping/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: paymentAgentMerchant.merchantCode ?? "",
            paymentAgentId: paymentAgentMerchant.paymentAgentId ?? "",
            pageNo: paymentAgentMerchant.pageNo,
            pageSize: paymentAgentMerchant.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    async createPaymentAgentMerchant(paymentAgentMerchant) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/paymentAgentMapping/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/paymentAgentMapping/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: paymentAgentMerchant.merchantCode ?? "",
            paymentAgentId: paymentAgentMerchant.paymentAgentId ?? "",
            paymentAgentCode: paymentAgentMerchant.paymentAgentCode ?? ""
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating payment agent." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    async updatePaymentAgentMerchant(paymentAgentMerchant) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/paymentAgentMapping/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/paymentAgentMapping/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: paymentAgentMerchant.id ?? "",
            merchantCode: paymentAgentMerchant.merchantCode ?? "",
            paymentAgentId: paymentAgentMerchant.paymentAgentId ?? "",
            paymentAgentCode: paymentAgentMerchant.paymentAgentCode ?? ""
        }
        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating payment agent." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getMerchantChannel(merchantChannel) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantChannel/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantChannel/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: merchantChannel.merchantCode ?? "",
            merchantId: merchantChannel.merchantId ?? "",
            pageNo: merchantChannel.pageNo,
            pageSize: merchantChannel.pageSize
        }
        console.log(body)
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    async createMerchantChannel(merchantChannel) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantChannel/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantChannel/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: merchantChannel.merchantCode ?? "",
            merchantId: merchantChannel.merchantId ?? ""
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating payment agent." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateMerchantChannel(merchantChannel) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantChannel/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantChannel/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: merchantChannel.id ?? "",
            merchantCode: merchantChannel.merchantCode ?? "",
            merchantId: merchantChannel.merchantId ?? ""
        }
        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating payment agent." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getMerchantParameters(merchantChannel) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantMapping/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantMapping/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: merchantChannel.merchantCode ?? "",
            pageNo: merchantChannel.pageNo,
            pageSize: merchantChannel.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createMerchantParameters(merchantParameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantMapping/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantMapping/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: merchantParameters.merchantCode ?? "",
            payconnectReferenceMap: merchantParameters.payconnectReferenceMap ?? "",
            merchantReferenceMap: merchantParameters.merchantReferenceMap ?? "",
            amountMap: merchantParameters.amountMap ?? "",
            transactionDateMap: merchantParameters.transactionDateMap ?? "",
            transactionDateFormat: merchantParameters.transactionDateFormat ?? "",
            typeMap: merchantParameters.typeMap ?? "",
            typeCondition: merchantParameters.typeCondition ?? "",
            statusMap: merchantParameters.statusMap ?? "",
            statusCondition: merchantParameters.statusCondition ?? "",
            externalReferenceMap: merchantParameters.externalReferenceMap ?? "",
            unmatchedRetryDays: merchantParameters.unmatchedRetryDays ?? ""
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateMerchantParameters(merchantParameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantMapping/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantMapping/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: merchantParameters.id ?? "",
            merchantCode: merchantParameters.merchantCode ?? "",
            payconnectReferenceMap: merchantParameters.payconnectReferenceMap ?? "",
            merchantReferenceMap: merchantParameters.merchantReferenceMap ?? "",
            amountMap: merchantParameters.amountMap ?? "",
            transactionDateMap: merchantParameters.transactionDateMap ?? "",
            transactionDateFormat: merchantParameters.transactionDateFormat ?? "",
            typeMap: merchantParameters.typeMap ?? "",
            typeCondition: merchantParameters.typeCondition ?? "",
            statusMap: merchantParameters.statusMap ?? "",
            statusCondition: merchantParameters.statusCondition ?? "",
            externalReferenceMap: merchantParameters.externalReferenceMap ?? "",
            unmatchedRetryDays: merchantParameters.unmatchedRetryDays ?? ""
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    async getSettlementBatch(settlementValue, batchStatus) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/settlement/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/settlement/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: settlementValue.merchantCode ?? "",
            settlementReference: settlementValue.settlementReference ?? "",
            settlementStatus: batchStatus,
            dateFrom: settlementValue.dateFrom ?? "",
            dateTo: settlementValue.dateTo ?? "",
            pageNo: settlementValue.pageNo,
            pageSize: settlementValue.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateSettlementBatchForApproval(settlementBatch) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/settlement/preapproveAsync`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/settlement/preapproveAsync`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: settlementBatch.merchantCode,
            dateFrom: settlementBatch.dateFrom,
            dateTo: settlementBatch.dateTo,
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateSettlementBatchToApprove(settlementBatch) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/settlement/approve`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/settlement/approve`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: settlementBatch.id,
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateSettlementBatchToSettle(settlementBatch) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/settlement/settle`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/settlement/settle`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: settlementBatch.id,
            bank: settlementBatch.bank,
            bankAccountNumber: settlementBatch.bankAccountNumber,
            bankReference: settlementBatch.bankReference,
            bankTransactionDate: settlementBatch.bankTransactionDate
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async exportSettlementToCSVorPDF(toDownload, format) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/settlement/export`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/settlement/export`
        }

        const config = {
            responseType: 'arraybuffer',
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: toDownload.id,
            format: format
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                if (format === "csv") {
                    link.setAttribute('download', `${toDownload.settlementReference}.csv`);
                } else {
                    link.setAttribute('download', `${toDownload.settlementReference}.pdf`);
                }
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    /**
    * Get list of Biller Account Status
    */
    async getBillersList() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${billingSystemUrl}/api/bill/getBillers`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/biller/api/bill/getBillers`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }

        try {
            const response = await Vue.axios.get(url, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async uploadFileMerchant(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/v1/uploadMerchantCsvAsync`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/v1/uploadMerchantCsvAsync`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'multipart/form-data'
            }
        }
        try {
            const response = await Vue.axios.post(url, formData, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error in Send Sale." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getUploadedFileList(uploadedFileList) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantFileUploadHistory/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantFileUploadHistory/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            merchantCode: uploadedFileList.merchantCode ?? "",
            filename: uploadedFileList.filename ?? "",
            fileUploadHistoryId: uploadedFileList.fileUploadHistoryId ?? "",
            dateFrom: uploadedFileList.dateFrom ?? "",
            dateTo: uploadedFileList.dateTo ?? "",
            pageNo: uploadedFileList.pageNo,
            pageSize: uploadedFileList.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of matched transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async exportMerchantFileUpload(toDownload) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantFileUploadHistory/export`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantFileUploadHistory/export`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: toDownload.id
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${toDownload.originalFilename}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateUnmatchedToDecline(unmatched) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantTransaction/decline`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantTransaction/decline`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            id: unmatched.id,
            name: unmatched.name,
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getBankList(bankList) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bank/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bank/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            code: bankList.code ?? "",
            pageNo: bankList.pageNo,
            pageSize: bankList.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createBank(bankCreated) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bank/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bank/create`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            code: bankCreated.code ?? "",
            name: bankCreated.name ?? ""
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateBank(bankUpdated) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bank/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bank/update`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            id: bankUpdated.id ?? "",
            code: bankUpdated.code ?? "",
            name: bankUpdated.name ?? ""
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getBankCodes() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bank/getBanks`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bank/getBanks`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        try {
            const response = await Vue.axios.get(url, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants code." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getBankAccountList(bankAccountList) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bankAccount/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bankAccount/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            bank: bankAccountList.bank ?? "",
            accountNumber: bankAccountList.accountNumber ?? "",
            accountName: bankAccountList.accountName ?? "",
            pageNo: bankAccountList.pageNo,
            pageSize: bankAccountList.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createBankAccount(bankAccountCreated) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bankAccount/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bankAccount/create`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            bank: bankAccountCreated.bank,
            accountName: bankAccountCreated.accountName,
            accountNumber: bankAccountCreated.accountNumber
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateBankAccount(bankAccountUpdated) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bankAccount/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bankAccount/update`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            id: bankAccountUpdated.id,
            bank: bankAccountUpdated.bank,
            accountName: bankAccountUpdated.accountName,
            accountNumber: bankAccountUpdated.accountNumber
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async exportMatchedTransaction(merchantCode, dateFrom, dateTo) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/matchedTransaction/export`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/matchedTransaction/export`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            },
            timeout: 200000,
        }
        const body = {
            merchantCode: merchantCode,
            dateFrom: dateFrom,
            dateTo: dateTo
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${merchantCode}_${dateFrom}_${dateTo}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of settlement transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async exportMerchantTransaction(merchantCode, dateFrom, dateTo, payconnectReference, merchantReference) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/merchantTransaction/export`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/merchantTransaction/export`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            },
            timeout: 200000,
        }
        const body = {
            merchantCode: merchantCode,
            dateFrom: dateFrom,
            dateTo: dateTo,
            payconnectReference: payconnectReference,
            merchantReference: merchantReference
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `UNMATCHED_${merchantCode}_MC_${dateFrom}_${dateTo}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchant transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async exportPayconnectTransaction(merchantCode, dateFrom, dateTo, payconnectReference, merchantReference) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/payconnectTransaction/export`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/payconnectTransaction/export`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            },
            timeout: 200000,
        }
        const body = {
            merchantCode: merchantCode,
            dateFrom: dateFrom,
            dateTo: dateTo,
            payconnectReference: payconnectReference,
            merchantReference: merchantReference
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `UNMATCHED_${merchantCode}_PC_${dateFrom}_${dateTo}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getBankAccounts() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/bankAccount/getBankAccounts`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/bankAccount/getBankAccounts`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        try {
            const response = await Vue.axios.get(url, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants code." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getDeclineReasonList(declineReasonList) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/declineReason/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/declineReason/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            name: declineReasonList.name ?? "",
            description: declineReasonList.description ?? "",
            pageNo: declineReasonList.pageNo,
            pageSize: declineReasonList.pageSize
        }
        console.log(body)
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createDeclineReason(declineReason) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/declineReason/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/declineReason/create`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            name: declineReason.name,
            description: declineReason.description,
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateDeclineReason(declineReason) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/declineReason/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/declineReason/update`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            id: declineReason.id,
            name: declineReason.name,
            description: declineReason.description,
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getDeclineReasons() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconModuleUrl}/declineReason/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/recon/declineReason/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        try {
            const response = await Vue.axios.get(url, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants code." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    //wallet credential setting APIs

    async getWalletCredentialList(walletCredentialList) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/config/listWalletTenants`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/config/listWalletTenants`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            code: walletCredentialList.code ?? "",
            displayName: walletCredentialList.displayName ?? "",
            pageNo: walletCredentialList.pageNo,
            pageSize: walletCredentialList.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createWalletCredentials(walletCredentials) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/config/createWalletTenant`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/config/createWalletTenant`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            code: walletCredentials.code ?? "",
            displayName: walletCredentials.displayName ?? "",
            baseUrl: walletCredentials.baseUrl ?? "",
            transactionEndpoint: walletCredentials.transactionEndpoint ?? "",
            accountsEndpoint: walletCredentials.accountsEndpoint ?? "",
            balanceEndpoint: walletCredentials.balanceEndpoint ?? "",
            debitEndpoint: walletCredentials.debitEndpoint ?? "",
            refundEndpoint: walletCredentials.refundEndpoint ?? "",
            isDataDriven: false,
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateWalletCredentials(walletCredentials) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/config/updateWalletTenant`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/config/updateWalletTenant`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            code: walletCredentials.code ?? "",
            displayName: walletCredentials.displayName ?? "",
            debitEndpoint: walletCredentials.debitEndpoint ?? "",
            refundEndpoint: walletCredentials.refundEndpoint ?? "",
            isDataDriven: false
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getWalletAccountList(walletAccountList) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/wallet/searchWalletAccounts`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/wallet/searchWalletAccounts`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            code: walletAccountList.code ?? "",
            displayName: walletAccountList.displayName ?? "",
            pageNo: walletAccountList.pageNo,
            pageSize: walletAccountList.pageSize
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createWalletAccount(WalletAccount) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/config/generate`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/config/generate`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            tenant: WalletAccount.tenant ?? "",
            keycloakRealmId: WalletAccount.keycloakRealmId ?? "",
            username: WalletAccount.username ?? "",
            password: WalletAccount.password ?? "",
            clientId: WalletAccount.clientId ?? "",
            configName: WalletAccount.configName ?? "",
            accountNumber: WalletAccount.accountNumber ?? "",
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateWalletAccount(WalletAccount) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/config/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/config/update`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }

        const body = {
            configName: WalletAccount.configName ?? "",
            accountNumber: WalletAccount.accountNumber ?? "",
        }

        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of payconnect transactions." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getWalletAccounts() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/wallet/listWalletAccounts`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/wallet/listWalletAccounts`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        try {
            const response = await Vue.axios.get(url, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants code." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },




    async getWalletTenantList() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/config/getWalletTenants`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/config/getWalletTenants`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        try {
            const response = await Vue.axios.get(url, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants code." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },


    //RECON-THRESHOLD APIs

    //disabledStore.vue
    async getDisabledStoresRecon(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/listDisabled`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/listDisabled`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            storeNo: query.storeNo ?? '',
            storeName: query.storeName ?? '',
            dateFrom: query.dateFrom ?? '',
            dateTo: query.dateTo ?? ''
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of disabled stores." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async enableStoreRecon(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/enableStore`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/enableStore`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            id: parameters.id,
            storeNo: parameters.storeNo,
            storeName: parameters.storeName
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error enabling store." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    //merchantFilter.vue
    async getFilteredMerchantsRecon() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/listFiltered`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/listFiltered`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: 0,
            pageSize: 0,
            name: ''
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of filtered merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateMerchantFilterRecon(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/updateFiltered`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/updateFiltered`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            merchantFilters: parameters.merchants
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating threshold." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllMerchantsRecon() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/listMerchants`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/listMerchants`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: 0,
            pageSize: 0,
            name: ''
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    //StoreEventLog
    async getStoreEventLogRecon(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/store/searchEventLog`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/store/searchEventLog`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            storeNo: query.storeNo ?? '',
            storeName: query.storeName ?? '',
            remarks: query.remarks ?? '',
            dateCreatedFrom: query.dateFrom ?? '',
            dateCreatedTo: query.dateTo ?? ''
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of stores event logs." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    //Threshold Management
    async getThresholdsRecon(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            type: query.type ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createThreshold(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            type: parameters.type,
            count: parameters.count,
            amount: parameters.amount,
            remarks: parameters.remarks,
            isEnabled: parameters.isEnabled

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating threshold." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateThreshold(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${reconDashboardUrl}/threshold/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `recondashboard/threshold/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            type: parameters.type,
            count: parameters.count,
            amount: parameters.amount,
            remarks: parameters.remarks,
            isEnabled: parameters.isEnabled
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating threshold." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    //mobile top up

    async uploadFileTopupCSV(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${walletModuleUrl}/api/topup/upload`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/wallet/api/topup/upload`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'multipart/form-data'
            }
        }
        try {
            const response = await Vue.axios.post(url, formData, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error in uploading CSV." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async downloadVisaCTF(datePicked, dateCreated) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/downloadCTF`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/downloadCTF`
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            },
            responseType: 'blob',
            timeout: 200000,
        }
        const body = {
            date: dateCreated,
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${datePicked}.zip`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "No transaction found" };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async uploadVisaCTF(formData) {
        let url = `${dashboardUrl}/report/uploadCTF`;
        if (isProxy) {
            url = `/tdm/report/uploadCTF`;
        }

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'blob'
        };

        try {
            const response = await Vue.axios.post(url, formData, config);
            if (response && response.status === 200) {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'visa-settlement.pdf');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
                return downloadUrl;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error in uploading CTF." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error);
        }
    },

    async uploadVisaCTF(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/uploadCTF`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/uploadCTF`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                'Content-Type': 'multipart/form-data'
            },

            responseType: 'blob'
        }
        try {
            const response = await Vue.axios.post(url, formData, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `visa-settlement.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error in uploading CTF." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createCurrency(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/currency/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/currency/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            country: parameters.countryName,
            code: parameters.code,
            name: parameters.name,
            numCode: parameters.numCode,
            symbol: parameters.symbol,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log("RES", response)
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating currency." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateCurrency(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/currency/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/currency/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            country: parameters.countryName,
            code: parameters.code,
            name: parameters.name,
            numCode: parameters.numCode,
            symbol: parameters.symbol,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating currency." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },



    async getAllCurrencies() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/currency/listCurrencies`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/currency/listCurrencies`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log("CURR", response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of currencies." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async searchCurrencies(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/currency/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/currency/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            country: query.country ?? '',
            numCode: query.numCode ?? '',
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of currencies." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getEmvs(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/emv/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/emv/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            emvId: query.emvParameterIndex ?? ''
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of emvs." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },



    async createEmv(params) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/emv/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `tdm/emv/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            emvId: params.emvParameterIndex,
            schemeReference: params.schemeReference ?? "",
            issuerReference: params.issuerReference ?? "",
            trmDataPresent: params.trmDataPresent ?? "",
            floorLimit: params.floorLimit ?? "",
            rsThreshold: params.rsThreshold ?? "",
            targetRs: params.targetRs ?? "",
            maxTargetRs: params.maxTargetRs ?? "",
            tacDefault: params.tacDefault ?? "",
            tacDenial: params.tacDenial ?? "",
            tacOnline: params.tacOnline ?? "",
            defaultTDOL: params.defaultTDOL ?? "",
            defaultDDOL: params.defaultDDOL ?? "",
            nextRecord: params.nextRecord ?? "",
            // emvCount: params.emvCount ?? "",
            // termCountryCode: params.termCountryCode ?? "",
            // termCurrencyCode: params.termCurrencyCode ?? "",
            // termCapabilities: params.termCapabilities ?? "",
            // termAddCapabilities: params.termAddCapabilities ?? "",
            // termType: params.termType ?? "",
            mcc: params.mcc ?? "",
            contactlessCvmLimit: params.contactlessCvmLimit ?? ""
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating Emv." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async updateEmv(params) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/emv/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `tdm/emv/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            emvId: params.emvParameterIndex,
            schemeReference: params.schemeReference ?? "",
            issuerReference: params.issuerReference ?? "",
            trmDataPresent: params.trmDataPresent ?? "",
            floorLimit: params.floorLimit ?? "",
            rsThreshold: params.rsThreshold ?? "",
            targetRs: params.targetRs ?? "",
            maxTargetRs: params.maxTargetRs ?? "",
            tacDefault: params.tacDefault ?? "",
            tacDenial: params.tacDenial ?? "",
            tacOnline: params.tacOnline ?? "",
            defaultTDOL: params.defaultTDOL ?? "",
            defaultDDOL: params.defaultDDOL ?? "",
            nextRecord: params.nextRecord ?? "",
            // emvCount: params.emvCount ?? "",
            // termCountryCode: params.termCountryCode ?? "",
            // termCurrencyCode: params.termCurrencyCode ?? "",
            // termCapabilities: params.termCapabilities ?? "",
            // termAddCapabilities: params.termAddCapabilities ?? "",
            // termType: params.termType ?? "",
            mcc: params.mcc ?? "",
            contactlessCvmLimit: params.contactlessCvmLimit ?? ""
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating emv." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllEmvs() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/emv/listEmvs`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/emv/listEmvs`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Emvs." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllCardSchemeIds() {
      /**Use when CORS issue is resolved, directly communicate to server without proxy*/
      var url = `${dashboardUrl}/cardScheme/cardSchemeList`
      if(isProxy) {
        /**Use when CORS issue persists, and use proxy*/
        url = `/tdm/cardScheme/cardSchemeList`
      }
      const config = {
        headers: {
          Authorization: `${router.app.$keycloak.token}`
        }
      }
      const body = {
      }

      try {
        const response = await Vue.axios.get(url, body, config);
        console.log(response);
        if (response && response.data && response.status == 200) {
          return response.data;
        } else if (response && response.data && response.data.message) {
          return { error: response.data.message };
        } else {
          return { error: "Sorry. Error getting list of Emvs." };
        }
      } catch (error) {
        console.log(error);
        return this.getError(error)
      }
    },

    async getSchemes(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardScheme/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/cardScheme/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            cardSchemeId: query.cardSchemeId ?? ''

        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Payment Networks." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },



    async createCardScheme(params) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardScheme/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `tdm/cardScheme/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            cardSchemeIndex: params.cardSchemeIndex,
            cardSchemeId: params.cardSchemeId,
            eptRecord: params.eptRecord,
            rid: params.rid ?? "",
            acquirerId: params.acquirer.acquirerId,
            capkIndex1: params.capkIndex1 ?? "",
            capkFile1: params.capkFile1 ?? "",
            capkExptDate1: params.capkExptDate1 ?? "",
            capkIndex2: params.capkIndex2 ?? "",
            capkFile2: params.capkFile2 ?? "",
            capkExptDate2: params.capkExptDate2 ?? "",
            capkIndex3: params.capkIndex3 ?? "",
            capkFile3: params.capkFile3 ?? "",
            capkExptDate3: params.capkExptDate3 ?? "",
            capkIndex4: params.capkIndex4 ?? "",
            capkFile4: params.capkFile4 ?? "",
            capkExptDate4: params.capkExptDate4 ?? "",
            capkIndex5: params.capkIndex5 ?? "",
            capkFile5: params.capkFile5 ?? "",
            capkExptDate5: params.capkExptDate5 ?? "",
            capkIndex6: params.capkIndex6 ?? "",
            capkFile6: params.capkFile6 ?? "",
            capkExptDate6: params.capkExptDate6 ?? "",
            capkIndex7: params.capkIndex7 ?? "",
            capkFile7: params.capkFile7 ?? "",
            capkExptDate7: params.capkExptDate7 ?? "",
            capkIndex8: params.capkIndex8 ?? "",
            capkFile8: params.capkFile8 ?? "",
            capkExptDate8: params.capkExptDate8 ?? "",
            capkIndex9: params.capkIndex9 ?? "",
            capkFile9: params.capkFile9 ?? "",
            capkExptDate9: params.capkExptDate9 ?? "",
            capkIndex10: params.capkIndex10 ?? "",
            capkFile10: params.capkFile10 ?? "",
            capkExptDate10: params.capkExptDate10 ?? "",
            supportedAid1: params.supportedAid1 ?? "",
            partialNameFlag1: params.partialNameFlag1 ?? 0,
            termAvn1: params.termAvn1 ?? "",
            secondTermAvn1: params.secondTermAvn1 ?? "",
            supportedAid2: params.supportedAid2 ?? "",
            partialNameFlag2: params.partialNameFlag2 ?? 0,
            termAvn2: params.termAvn2 ?? "",
            secondTermAvn2: params.secondTermAvn2 ?? "",
            supportedAid3: params.supportedAid3 ?? "",
            partialNameFlag3: params.partialNameFlag3 ?? 0,
            termAvn3: params.termAvn3 ?? "",
            secondTermAvn3: params.secondTermAvn3 ?? "",
            supportedAid4: params.supportedAid4 ?? "",
            partialNameFlag4: params.partialNameFlag4 ?? 0,
            termAvn4: params.termAvn4 ?? "",
            secondTermAvn4: params.secondTermAvn4 ?? "",
            supportedAid5: params.supportedAid5 ?? "",
            partialNameFlag5: params.partialNameFlag5 ?? 0,
            termAvn5: params.termAvn5 ?? "",
            secondTermAvn5: params.secondTermAvn5 ?? "",
            supportedAid6: params.supportedAid6 ?? "",
            partialNameFlag6: params.partialNameFlag6 ?? 0,
            termAvn6: params.termAvn6 ?? "",
            secondTermAvn6: params.secondTermAvn6 ?? "",
            supportedAid7: params.supportedAid7 ?? "",
            partialNameFlag7: params.partialNameFlag7 ?? 0,
            termAvn7: params.termAvn7 ?? "",
            secondTermAvn7: params.secondTermAvn7 ?? "",
            supportedAid8: params.supportedAid8 ?? "",
            partialNameFlag8: params.partialNameFlag8 ?? 0,
            termAvn8: params.termAvn8 ?? "",
            secondTermAvn8: params.secondTermAvn8 ?? "",
            supportedAid9: params.supportedAid9 ?? "",
            partialNameFlag9: params.partialNameFlag9 ?? 0,
            termAvn9: params.termAvn9 ?? "",
            secondTermAvn9: params.secondTermAvn9 ?? "",
            supportedAid10: params.supportedAid10 ?? "",
            partialNameFlag10: params.partialNameFlag10 ?? 0,
            termAvn10: params.termAvn10 ?? "",
            secondTermAvn10: params.secondTermAvn10 ?? "",
            type: params.type ?? ""
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error creating Payment Network." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createCardSchemeId(params) {
      var url = `${dashboardUrl}/cardScheme/createCardSchemeList`
      if(isProxy) {
        /**Use when CORS issue persists, and use proxy*/
        url = `tdm/cardScheme/createCardSchemeList`
      }
      const config = {
        headers: {
          Authorization: `${router.app.$keycloak.token}`
        }
      }
      const body = {
        id: params.id,
        // cardSchemeCode: params.cardSchemeCode,
        name: params.name
      }
      try {
        const response = await Vue.axios.post(url, body, config);
        console.log(response);
        if (response && response.data && response.status == 201) {
          return response.data;
        } else if (response && response.data && response.data.message) {
          return { error: response.data.message };
        } else {
          return { error: "Sorry. Error creating Payment Network." };
        }
      } catch (error) {
        console.log(error);
        return this.getError(error)
      }
    },

    async updateCardScheme(params) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardScheme/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `tdm/cardScheme/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            cardSchemeIndex: params.cardSchemeIndex,
            cardSchemeId: params.cardSchemeId,
            eptRecord: params.eptRecord,
            acquirerId: params.acquirer.acquirerId,
            rid: params.rid ?? "",
            capkIndex1: params.capkIndex1 ?? "",
            capkFile1: params.capkFile1 ?? "",
            capkExptDate1: params.capkExptDate1 ?? "",
            capkIndex2: params.capkIndex2 ?? "",
            capkFile2: params.capkFile2 ?? "",
            capkExptDate2: params.capkExptDate2 ?? "",
            capkIndex3: params.capkIndex3 ?? "",
            capkFile3: params.capkFile3 ?? "",
            capkExptDate3: params.capkExptDate3 ?? "",
            capkIndex4: params.capkIndex4 ?? "",
            capkFile4: params.capkFile4 ?? "",
            capkExptDate4: params.capkExptDate4 ?? "",
            capkIndex5: params.capkIndex5 ?? "",
            capkFile5: params.capkFile5 ?? "",
            capkExptDate5: params.capkExptDate5 ?? "",
            capkIndex6: params.capkIndex6 ?? "",
            capkFile6: params.capkFile6 ?? "",
            capkExptDate6: params.capkExptDate6 ?? "",
            capkIndex7: params.capkIndex7 ?? "",
            capkFile7: params.capkFile7 ?? "",
            capkExptDate7: params.capkExptDate7 ?? "",
            capkIndex8: params.capkIndex8 ?? "",
            capkFile8: params.capkFile8 ?? "",
            capkExptDate8: params.capkExptDate8 ?? "",
            capkIndex9: params.capkIndex9 ?? "",
            capkFile9: params.capkFile9 ?? "",
            capkExptDate9: params.capkExptDate9 ?? "",
            capkIndex10: params.capkIndex10 ?? "",
            capkFile10: params.capkFile10 ?? "",
            capkExptDate10: params.capkExptDate10 ?? "",
            supportedAid1: params.supportedAid1 ?? "",
            partialNameFlag1: params.partialNameFlag1 ?? 0,
            termAvn1: params.termAvn1 ?? "",
            secondTermAvn1: params.secondTermAvn1 ?? "",
            supportedAid2: params.supportedAid2 ?? "",
            partialNameFlag2: params.partialNameFlag2 ?? 0,
            termAvn2: params.termAvn2 ?? "",
            secondTermAvn2: params.secondTermAvn2 ?? "",
            supportedAid3: params.supportedAid3 ?? "",
            partialNameFlag3: params.partialNameFlag3 ?? 0,
            termAvn3: params.termAvn3 ?? "",
            secondTermAvn3: params.secondTermAvn3 ?? "",
            supportedAid4: params.supportedAid4 ?? "",
            partialNameFlag4: params.partialNameFlag4 ?? 0,
            termAvn4: params.termAvn4 ?? "",
            secondTermAvn4: params.secondTermAvn4 ?? "",
            supportedAid5: params.supportedAid5 ?? "",
            partialNameFlag5: params.partialNameFlag5 ?? 0,
            termAvn5: params.termAvn5 ?? "",
            secondTermAvn5: params.secondTermAvn5 ?? "",
            supportedAid6: params.supportedAid6 ?? "",
            partialNameFlag6: params.partialNameFlag6 ?? 0,
            termAvn6: params.termAvn6 ?? "",
            secondTermAvn6: params.secondTermAvn6 ?? "",
            supportedAid7: params.supportedAid7 ?? "",
            partialNameFlag7: params.partialNameFlag7 ?? 0,
            termAvn7: params.termAvn7 ?? "",
            secondTermAvn7: params.secondTermAvn7 ?? "",
            supportedAid8: params.supportedAid8 ?? "",
            partialNameFlag8: params.partialNameFlag8 ?? 0,
            termAvn8: params.termAvn8 ?? "",
            secondTermAvn8: params.secondTermAvn8 ?? "",
            supportedAid9: params.supportedAid9 ?? "",
            partialNameFlag9: params.partialNameFlag9 ?? 0,
            termAvn9: params.termAvn9 ?? "",
            secondTermAvn9: params.secondTermAvn9 ?? "",
            supportedAid10: params.supportedAid10 ?? "",
            partialNameFlag10: params.partialNameFlag10 ?? 0,
            termAvn10: params.termAvn10 ?? "",
            secondTermAvn10: params.secondTermAvn10 ?? "",
            type: params.type ?? "",
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error updating emv." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllCardSchemes(networkParam) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardScheme/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/cardScheme/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            network: networkParam ?? ""
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Payment Networks." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getAllCardSchemesV2(networkParam) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardScheme/listV2`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/cardScheme/listV2`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            network: networkParam ?? ""
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Payment Networks." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getCardSchemesFromMerchant(params) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardScheme/listFromMerchant`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/cardScheme/listFromMerchant`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            merchantId: params ?? ""
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Payment Networks." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },


    async uploadBinRange(formData) {
      /**Use when CORS issue is resolved, directly communicate to server without proxy*/
      var url = `${dashboardUrl}/cardScheme/saveBINs`
      if(isProxy) {
        /**Use when CORS issue persists, and use proxy*/
        url = `/tdm/cardScheme/saveBINs`
      }
      const config = {
        headers: {
          Authorization: `${router.app.$keycloak.token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
      try {
        const response = await Vue.axios.post(url, formData, config);
        console.log(response);
        if (response && response.data && response.status == 200) {
          return response.data;
        } else if (response && response.data && response.data.message) {
          return { error: response.data.message };
        } else {
          return { error: "Sorry. Error in Send File." };
        }
      } catch (error) {
        console.log(error);
        return this.getError(error)
      }
    },
    async getCardDefinitions(offset, limit, formData) {
      console.log("formData", formData)
      /**Use when CORS issue is resolved, directly communicate to server without proxy*/
      var url = `${dashboardUrl}/cardDefinition/searchV2`

    //   if(formData.bin === "" && formData.network === "") {
    //     url = `${dashboardUrl}/cardDefinition/listV2`
    //   }

    //   if(isProxy) {
    //     /**Use when CORS issue persists, and use proxy*/
    //     url = `/tdm/cardDefinition/searchV2`
    //     if(formData.bin === "") {
    //       url = `${dashboardUrl}/cardDefinition/list`
    //     }
        // }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            bin: formData.bin,
            network: formData.network

        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Card Definition." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },
    async getVisaBinRecord(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/visaBinRecordsSearch`;
        if (formData.bin === "") {
            url = `${dashboardUrl}/report/visaBinRecordsList`;
        }
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/visaBinRecordsSearch`;
            if (formData.bin === "") {
                url = `/tdm/report/visaBinRecordsList`;
            }
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            },
        };
        const body = {
            pageNo: ``,
            pageSize: `10`,

            bin: `${formData.bin}`,
        };

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
              return response.data;
            } else if (response && response.data && response.data.message) {
              return { error: response.data.message };
            } else {
              return { error: "Sorry. Error getting list of Visa Bin Range." };
            }
          } catch (error) {
            console.log(error);
            return this.getError(error)
          }
        },
    async getMayaBinRange(formData) {


      /**Use when CORS issue is resolved, directly communicate to server without proxy*/
      var url = `${dashboardUrl}/cardScheme/binRangeSearch`

      if (formData.bin === "") {
        url = `${dashboardUrl}/cardScheme/binRangeList`
      }
      if(isProxy) {
        /**Use when CORS issue persists, and use proxy*/
        url = `/tdm/cardScheme/binRangeSearch`
        if (formData.bin === "") {
          url = `/tdm/cardScheme/binRangeList`
        }
      }
      const config = {
        headers: {
          Authorization: `${router.app.$keycloak.token}`
        }
      }
      const body = {
        pageNo: ``,
        pageSize: `10`,
        bin: `${formData.bin}`
      }

      try {
        const response = await Vue.axios.post(url, body, config);
        console.log(response);
        if (response && response.data && response.status == 200) {
          return response.data;
        } else if (response && response.data && response.data.message) {
          return { error: response.data.message };
        } else {
          return { error: "Sorry. Error getting list of Bin Range." };
        }
      } catch (error) {
        console.log(error);
        return this.getError(error)
      }
    },
    async getAcquirers(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/acquirer/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/acquirer/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: ``,
            pageSize: `10`,
            acquirerName: `${formData.acquirerName}`
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Payment Networks." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },
    async getAcquirerOptions() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/acquirer/acquirerList`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/acquirer/acquirerList`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.get(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of Payment Networks." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createAcquirer(formData) {

        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/acquirer/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/acquirer/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            acquirerId: `${formData.acquirerId}`,
            acquirerName: `${formData.acquirerName}`,
            acquirerCode: `${formData.acquirerCode}`
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 201) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async createCardDefinition(formData) {

        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardDefinition/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/cardDefinition/create`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            // bin: `${formData.bin}`,
            low: `${formData.low}`,
            high: `${formData.high}`,
            isSupported: `${formData.isSupported}`,
            issuingInstitution: `${formData.issuingInstitution}`,
            scheme: `${formData.cardScheme}`,
            network: `${formData.network}`,
            type: `${formData.cardType}`
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 201) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async updateAcquirer(formData) {

        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/acquirer/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/acquirer/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            acquirerId: `${formData.acquirerId}`,
            acquirerName: `${formData.acquirerName}`,
            acquirerCode: `${formData.acquirerCode}`
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async updateCardDefinition(formData) {

        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardDefinition/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/cardDefinition/update`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            // bin: `${formData.bin}`,
            id: `${formData.id}`,
            low: `${formData.low}`,
            high: `${formData.high}`,
            isSupported: `${formData.isSupported}`,
            issuingInstitution: `${formData.issuingInstitution}`,
            scheme: `${formData.cardScheme}`,
            network: `${formData.network}`,
            type: `${formData.cardType}`
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http status code
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * timestamp - datestring; yyyy-MM-ddTHH:mm:ss.SSS+00:00; optional reponse
                 * status - int; http status code; optional response
                 * statusCode - string; http status codel optional response
                 * message - string; always
                 * expired - boolean; optional response
                 */
                return { error: response.data.message };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },

    async acquirerList() {

        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/acquirer/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/acquirer/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async cardDefinitionList() {

        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/cardDefinition/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/cardDefinition/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getTransactionHistoryById(offset, limit, parameters) {
        /** Use when CORS issue is resolved, directly communicate to server without proxy */
        var url = `${dashboardUrl}/history/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/history/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            },
        };
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            transactionId: parameters.transactionHistoryId,
        };
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            }
            if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }
            return { error: 'Sorry. Error getting details of Transaction History.' };
        } catch (error) {
            console.log(error);
            return { error };
        }
    },


    //settlement list display
    async searchTerminalSettlementById(offset, limit, parameters) {
        /** Use when CORS issue is resolved, directly communicate to server without proxy */
        var url = `${dashboardUrl}/settlementApi/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/settlementApi/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            },
        };
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            dateFrom: parameters.dateFrom ?? '',
            dateTo: parameters.dateTo ?? '',
            terminalId: parameters.terminalId ?? '',
        };
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            }
            if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }
            return { error: 'Sorry. Error getting details of Settled Transactions.' };
        } catch (error) {
            console.log(error);
            return { error };
        }
    },

    //settled transactions list
    async getSettledTransactionList(offset, limit, parameters) {
        /** Use when CORS issue is resolved, directly communicate to server without proxy */
        var url = `${dashboardUrl}/settlementApi/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/settlementApi/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            },
        };
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            terminalId: parameters.terminalId ?? '',
            batchNumber: parameters.batchNumber ?? '',
            dateSettled: parameters.dateSettled ?? '',
        };
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            }
            if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }
            return { error: 'Sorry. Error getting details of Transaction History.' };
        } catch (error) {
            console.log(error);
            return { error };
        }
    },

    async refundCardPayment(params) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/payment/card/void`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `payment/card/void`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            }
        }
        const body = {
            merchant: {
                acquiringTerminal: {
                    id: params.id
                }
            },
            transaction: {
                amount: {
                    total: {
                        currency: "PHP",
                        value: params.amount
                    }
                }
            },
            reason: params.reason,
            reasonCode: params.reasonCode,
            trace: {
                batchNo: params.batchNumber,
                traceNo: params.stan
            }
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.status == 200) {
                return response;
            } else if (response && response.data && response.data.message) {
                return { error: response };
            } else {
                return { error: "Sorry. Please Try Again" };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getMerchantReports(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/listMerchantReports`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/listMerchantReports`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            merchantId: parameters.merchantId,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchant reports." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getMerchantOtcReports(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/listMerchantOtcReports`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/listMerchantOtcReports`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            merchantName: parameters.merchantName,
            transactionDate: parameters.transactionDate,
            merchantId: parameters.merchantId,
            excludeMerchantId: parameters.excludeMerchantId
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchant reports." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },


    async downloadMerchantReports(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/downloadMerchantReport`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/downloadMerchantReport`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            fileLocation: parameters.fileLocation,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error downloading merchant report." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async downloadMerchantOtcReports(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/downloadMerchantOtcReport`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/downloadMerchantOtcReport`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            fileLocation: parameters.fileLocation,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error downloading merchant report." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async exportMerchantData(offset, limit, parameters) {
        const url = `${dashboardUrl}/report/downloadMerchantData`;
        const config = {
        headers: {
            Authorization: `${router.app.$keycloak.token}`
        }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            name: parameters.name,
            mobileNumber: parameters.mobileNumber,
            email: parameters.email,
            merchantId: parameters.merchantId,
            merchantCode: parameters.merchantCode,
            enabled: parameters.enabled,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async listCTFReports(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/listCTFReports`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/listCTFReports`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            startDate: parameters.dateFrom ? moment(parameters.dateFrom).format('YYYYMMDD') : '',
            endDate: parameters.dateTo ? moment(parameters.dateTo).format('YYYYMMDD') : '',
            page: offset,
            size: limit,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log('response', response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of CTF reports." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async downloadReversalReport(parameters) {
        var url = `${dashboardUrl}/report/downloadReversalReport`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/downloadReversalReport`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            'Content-Type': 'application/json'
            },
            timeout: 200000,
        }
        const body = {
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${body.dateFrom}-${body.dateTo}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return url
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "No file found" };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async generateCTF(datePicked, dateCreated) {
        var url = `${dashboardUrl}/report/generateCTF`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/generateCTF`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            'Content-Type': 'application/json'
            },
            timeout: 200000,
        }
        const body = {
            date: dateCreated,
        }
        try {
            const response = await Vue.axios.post(url, body, config)

            if (response && response.data && response.status === 200) {
                return response.data   // ✅ RETURN FULL OBJECT
            }

            return { error: "Error generating report." }

        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async downloadCTF(outputFilename) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/downloadCTFReport`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/downloadCTFReport`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            date: outputFilename,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                // If response.data is a URL string, clean it and use it directly
                if (typeof response.data === 'string' && response.data.includes('amazonaws.com')) {
                    const cleanUrl = response.data.trim().replace(/\s+/g, '');
                    console.log("Cleaned URL:", cleanUrl);

                    const link = document.createElement('a');
                    link.href = cleanUrl;
                    link.setAttribute('download', `${outputFilename}.zip`);
                    link.setAttribute('target', '_blank'); // Open in new tab as fallback
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return cleanUrl;
                }
                return response;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error downloading CTF report." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async generateDOCA(datePicked, dateCreated, networkParam) {
        var url = `${dashboardUrl}/report/generateDOCA`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/generateDOCA`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            'Content-Type': 'application/json'
            },
            timeout: 200000,
        }
        const body = {
            date: dateCreated,
            network: networkParam
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data.filename && response.status == 200) {
                return response.data.filename;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "No transaction found" };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async downloadDOCA(outputFilename, networkParam) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/report/downloadDOCAReport`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/report/downloadDOCAReport`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            date: outputFilename,
            network: networkParam
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                // If response.data is a URL string, clean it and use it directly
                if (typeof response.data === 'string' && response.data.includes('amazonaws.com')) {
                    const cleanUrl = response.data.trim().replace(/\s+/g, '');
                    console.log("Cleaned URL:", cleanUrl);

                    const link = document.createElement('a');
                    link.href = cleanUrl;
                    link.setAttribute('download', `${outputFilename}.zip`);
                    link.setAttribute('target', '_blank'); // Open in new tab as fallback
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return cleanUrl;
                }
                return response;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error downloading DOCA report." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async searchPartners(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/ips/partners/lists`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/ips/partners/lists`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            partnerUuid: parameters.partnerUuid,
            partnerCode: parameters.partnerCode,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of partners." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async createPartner(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/ips/partners/onboardPartner`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/ips/partners/onboardPartner`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            partnerClientid: parameters.partnerClientid,
            partnerCode: parameters.partnerCode,
            callbackUrl: parameters.callbackUrl,
            callbackMaximumLoop: parameters.callbackMaximumLoop,
            callbackLoopInterval: parameters.callbackLoopInterval,
            enableRetryCallback: parameters.enableRetryCallback,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 201) {
                return response;
            } else if (response && response.error.message) {
                return { error: response.error.message };
            } else {
                return { error: "Sorry. Error creating partner." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async updatePartner(parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/ips/partners/update/${parameters.partnerUuid}`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/ips/partners/update/${parameters.partnerUuid}`
        }
        const config = {
            headers: {
                Authorization: `Bearer ${router.app.$keycloak.token}`
            }
        }
        const body = {
            partnerClientid: parameters.partnerClientid,
            partnerCode: parameters.partnerCode,
            callbackUrl: parameters.callbackUrl,
            callbackMaximumLoop: parameters.callbackMaximumLoop,
            callbackLoopInterval: parameters.callbackLoopInterval,
            enableRetryCallback: parameters.enableRetryCallback,
        }
        try {
            const response = await Vue.axios.put(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response;
            } else if (response && response.message) {
                return { error: response.message };
            } else {
                return { error: "Sorry. Error updating partner." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getSundries(offset, limit, query) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/sundry/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/sundry/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset.toString(),
            pageSize: limit.toString(),
            name: query.name ?? '',
            accountNumber: query.accountNumber ?? '',
            dateFrom: query.dateFrom ?? '',
            dateTo: query.dateTo ?? '',
            enabled: true
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of tickets." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async createSundry(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/sundry/create`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/sundry/create`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            name: formData.name,
            accountNumber: formData.accountNumber,
            network: formData.cardScheme,
            headerTransactionCode: formData.headerTransactionCode,
            childTransactionCode: formData.childTransactionCode,
            type: formData.type,
            headerDetails: formData.headerDetails,
            reconSuffix: formData.reconSuffix,
            transactionDetails: formData.transactionDetails,
            fileNamePrefix: formData.fileNamePrefix,
            transactingBranch: formData.transactingBranch,
            databaseId: formData.databaseId,
            companyCode: formData.companyCode,
            journalId: formData.journalId,
            currencyCode: formData.currencyCode,
            centerCode: formData.centerCode,
            glmAccounts: formData.glmAccounts
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                return { error: error.response.data.message };
            }
            return { error: error };
        }
    },

    async updateSundry(formData) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/sundry/update`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/sundry/update`
        }
        const config = {
            headers: {
                'Authorization': `${router.app.$keycloak.token}`,
                'Content-Type': 'application/json'
            }
        }
        const body = {
            name: formData.name,
            accountNumber: formData.accountNumber,
            network: formData.cardScheme,
            headerTransactionCode: formData.headerTransactionCode,
            childTransactionCode: formData.childTransactionCode,
            type: formData.type,
            headerDetails: formData.headerDetails,
            reconSuffix: formData.reconSuffix,
            transactionDetails: formData.transactionDetails,
            fileNamePrefix: formData.fileNamePrefix,
            transactingBranch: formData.transactingBranch,
            databaseId: formData.databaseId,
            companyCode: formData.companyCode,
            journalId: formData.journalId,
            currencyCode: formData.currencyCode,
            centerCode: formData.centerCode,
            glmAccounts: formData.glmAccounts
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 201) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getAllSundries() {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/sundry/list`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/sundry/list`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
        }

        try {
            const response = await Vue.axios.post(url, body, config);
            console.log(response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of roles." };
            }
        } catch (error) {
            console.log(error);
            return this.getError(error)
        }
    },

    async getTransactions(offset, limit, parameters) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/transaction/search`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/transaction/search`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            terminalId: parameters.terminalId,
            merchantId: parameters.merchantId,
            merchantCode: parameters.merchantCode,
            primaryAccountNumber: parameters.primaryAccountNumber,
            acquirerReferenceNumber: parameters.acquirerReferenceNumber,
            retrievalReferenceNumber: parameters.retrievalReferenceNumber,
            systemTraceAuditNumber: parameters.systemTraceAuditNumber,
            transactionType: parameters.transactionType,
            processingCode: parameters.processingCode,
            dateFrom: parameters.dateFrom,
            dateTo: parameters.dateTo
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                /*
                 * Response.data - JSON object and contains:
                 * message - string
                 * statusCode - string; http cpde
                 * transactions - JSON array of transaction objects
                 * transaction object contains:
                 * expiryDate - datestring; date the transaction will expire
                 * amount - decimal; transaction amount
                 * serviceCharge - decimal; transaction service charge
                 * dateCreated - datestring; date the transaction is created
                 * merchantReferenceNo - string; merchant reference number
                 * merchant - string; merchantId
                 * id - int; transaction identifier
                 * paymentStatus - string; status of transaction
                 * sevenPayID - string; payconnect reference number
                 */
                return response.data;
            } else if (response && response.data && response.data.message) {
                /*
                 * Response.data JSON object and contains:
                 * statusCode - string; http status code
                 * message - string
                 * expired - boolean
                 */
                return { error: response.data.message };
            } else {
                /**
                 * Return general error
                 */
                return { error: "Sorry. Error getting list of merchants." };
            }
        } catch (error) {
            /**
             * Exception error
             */
            console.log(error);
            return { error: error };
        }
    },


    // Fetch transactions for a specific merchant (by merchant ID)
    async getTransactionsByMerchant(offset, limit, params) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/pgtransactions/listByMerchant`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/pgtransactions/listByMerchant`
        }
        const config = {
            headers: {
                Authorization: `Bearer ${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            paymentMethodCode: 'OTC-711',
            merchantId: params.merchantId,
            accountNumber: params.accountNumber,
            referenceNumber: params.referenceNumber,
            merchantCode: params.merchantCode,
            processorTransactionId: params.processorTransactionId,
            status: params.status,
            merchantName: params.merchantName,
            paymentChannel: params.paymentChannel,
            dateFrom: params.dateFrom,
            dateTo: params.dateTo,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log("API Response:", response);

            if (response && response.data && response.status === 200) {
                return response.data;
            }

            if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }

            return { error: "Sorry. Error getting list of transactions." };

        } catch (error) {
            console.error("Error fetching transactions:", error);
            return {
                error: "Failed to load transactions. Please try again later."
            };
        }
    },

    async exportOtcTransactionsToCsv(offset, limit, params) {
        const url = `${dashboardUrl}/pgtransactions/exportTransactions`;
        const config = {
        headers: {
            Authorization: `Bearer ${router.app.$keycloak.token}`
        }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            paymentMethodCode: 'OTC-711',
            referenceNumber: params.referenceNumber,
            merchantCode: params.merchantCode,
            dateFrom: params.dateFrom,
            dateTo: params.dateTo,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of OTC transactions." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    // Fetch QR transactions (paymentMethod.code = QRPH) for a specific merchant
    async getQrTransactionsByMerchant(offset, limit, params) {
        var url = `${dashboardUrl}/pgtransactions/listByMerchant`
        if (isProxy) {
            url = `/tdm/pgtransactions/listByMerchant`
        }
        const config = {
            headers: {
                Authorization: `Bearer ${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            paymentMethodCode: 'QRPH',
            merchantId: params.merchantId,
            unifiedReference: params.unifiedReference,
            status: params.status,
            merchantName: params.merchantName,
            paymentChannel: params.paymentChannel,
            type: params.type,
            dateFrom: params.dateFrom,
            dateTo: params.dateTo,
        }
        try {
            const response = await Vue.axios.post(url, body, config);

            if (response && response.data && response.status === 200) {
                return response.data;
            }

            if (response && response.data && response.data.message) {
                return { error: response.data.message };
            }

            return { error: "Sorry. Error getting list of QR transactions." };

        } catch (error) {
            console.error("Error fetching QR transactions:", error);
            return {
                error: "Failed to load QR transactions. Please try again later."
            };
        }
    },

    async exportQrTransactionsToCsv(offset, limit, params) {
        const url = `${dashboardUrl}/pgtransactions/exportTransactions`;
        const config = {
            headers: {
                Authorization: `Bearer ${router.app.$keycloak.token}`
            }
        }
        const body = {
            pageNo: offset,
            pageSize: limit,
            paymentMethodCode: 'QRPH',
            unifiedReference: params.unifiedReference,
            status: params.status,
            merchantName: params.merchantName,
            paymentChannel: params.paymentChannel,
            type: params.type,
            dateFrom: params.dateFrom,
            dateTo: params.dateTo,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of QR transactions." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getMerchantApiKeys() {
        const url = `${dashboardUrl}/merchant/getApiKeys`;

        const config = {
            headers: {
                Authorization: `Bearer ${router.app.$keycloak.token}`
            }
        };

        try {
            const response = await Vue.axios.get(url, config);
            return response.data;
        } catch (error) {
            console.error("Error fetching api keys:", error);
            return { error: "Failed to load api keys." };
        }
    },

    async getMerchantResponseKey() {
        const url = `${dashboardUrl}/v2/mymerchant/getResponseKey`;

        const config = {
            headers: {
                Authorization: `Bearer ${router.app.$keycloak.token}`
            }
        };

        try {
            const response = await Vue.axios.get(url, config);
            return response.data;
        } catch (error) {
            console.error("Error fetching response key:", error);
            return { error: "Failed to load response key." };
        }
    },

    async getMerchantWebhookSettings() {
        var url = `${dashboardUrl}/merchant/getWebhookSettings`
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }

        try {
            const response = await Vue.axios.get(url, config);

            if (response.status === 200) {
                return response.data;
            } else {
                return {
                    error: "",
                };
            }
        }  catch (e) {
        return { error: e.response?.data || 'Request failed' }
        }
    },

    async updateMerchantWebhookSettings(payload) {
        const url = `${dashboardUrl}/merchant/updateWebhookSettings`

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }

        // ✅ payload already correct — DO NOT remap
        const body = {
            webhook: payload.webhook,
            merchantLogoUrl: payload.merchantLogoUrl,
            isWebhookEnabled: payload.isWebhookEnabled
        }

        try {
            const response = await Vue.axios.post(url, body, config)
            if (response && response.status === 200) {
                return response.data
            }
            return { error: 'Failed to update webhook settings' }
        } catch (error) {
            return this.getError(error)
        }
    },

    async listInstapayNotifications(offset, limit) {
        /**Use when CORS issue is resolved, directly communicate to server without proxy*/
        var url = `${dashboardUrl}/instapay-connection/list-notifications`
        if (isProxy) {
            /**Use when CORS issue persists, and use proxy*/
            url = `/tdm/instapay-connection/list-notifications`
        }
        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        const body = {
            page: offset,
            size: limit,
        }
        try {
            const response = await Vue.axios.post(url, body, config);
            console.log('response', response);
            if (response && response.data && response.status == 200) {
                return response.data;
            } else if (response && response.data && response.data.message) {
                return { error: response.data.message };
            } else {
                return { error: "Sorry. Error getting list of CTF reports." };
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async instapaySignOn() {
        const url = `${dashboardUrl}/instapay-connection/sign-on`

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        try {
             const response = await Vue.axios.post(url, {}, config);
             if (response && response.status === 200) {
                return response.data
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async instapaySignOff() {
        const url = `${dashboardUrl}/instapay-connection/sign-off`

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        try {
             const response = await Vue.axios.post(url, {}, config);
             if (response && response.status === 200) {
                return response.data
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getMerchantConfig(merchantId) {
        const url = `${dashboardUrl}/v2/merchant/merchant-config/${merchantId}`;

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            },
        };

        try {
            const response = await Vue.axios.get(url, config);

            if (response && response.status === 200) {
                return response.data;
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async getPaymentProcessors() {
        const url = `${dashboardUrl}/v2/merchant/payment-processors`;

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
            },
        };

        try {
            const response = await Vue.axios.get(url, config);

            if (response && response.status === 200) {
                return response.data;
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    async addPaymentConnector(payload) {
        const url = `${dashboardUrl}/v2/merchant/merchant-config/add-processor`;

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`,
                "Content-Type": "application/json",
            },
        };

        try {
            const response = await Vue.axios.post(url, payload, config);

            if (response && response.status === 200) {
                return response.data;
            }
        } catch (error) {
            console.log(error);
            return { error: error.response?.data?.error || "Failed to add payment processor" };
        }
    },

    async instapayEcho() {
        const url = `${dashboardUrl}/instapay-connection/echo`

        const config = {
            headers: {
                Authorization: `${router.app.$keycloak.token}`
            }
        }
        try {
             const response = await Vue.axios.post(url, {}, config);
             if (response && response.status === 200) {
                return response.data
            }
        } catch (error) {
            console.log(error);
            return { error: error };
        }
    },

    /**How to use the APIs above
   * Example:
   * import API from '@/api/API'
   * API.getMerchantList().then(response => {
      console.log(response)
    })
   * or------------------------
   * const merchantList = await API.getMerchantList()
   * The function where the above statement should be declared as async then
   */
}
